function getProductVariants(productId) {
  const element = document.querySelector(
    `[data-variant-json][data-variant-product="${productId}"]`
  );
  if (!element) {
    console.warn('Product variants element not found for product:', productId);
    return [];
  }
  return JSON.parse(element.value);
}

function parseCurrentSelection(productId) {
  const variants = getProductVariants(productId);
  if (!variants || variants.length === 0) {
    return null;
  }
  const selectElement = document.querySelector(
    `select[name="id"][data-productid="${productId}"]`
  );
  if (!selectElement) {
    console.warn('Product select element not found for product:', productId);
    return null;
  }
  const currentSelectionId = selectElement.value;
  const variant = variants.find((v) => v.id === parseInt(currentSelectionId));
  return variant;
}

function handleVariantFormChange(variant) {
  if (!variant) return;
  const productId =
    variant.featured_image && variant.featured_image.product_id
      ? variant.featured_image.product_id
      : parseInt(
          document
            .querySelector('.product-section[data-product-id]')
            .getAttribute('data-product-id')
        );
  for (let i = 0; i < variant.options.length; i++) {
    handleOptionContents(i, variant.options[i], productId);
  }

  document.querySelectorAll('[data-content="product-form"]').forEach((form) => {
    form.setAttribute('data-current-variant', variant.id);
  });

  handleVariantIdAssignments(variant, productId);
  handlePriceUpdates(variant, productId);
  handleSaleTagUpdates(variant, productId);
  handleAutoshipButtonUpdates(variant, productId);
  handleStickyUpdates(variant, productId);

  // Hack to trigger prop updates for fresh mini quiz
  handleMiniQuizUpdates();

  // Temporary patch in response to request to change default frequency based on bundle size
  // Going to be a hack because it should only be in use for a couple weeks
  if (productId && productId === 7044876435502) {
    handleFfdFrequencyCustomization(variant);
  }
}

function handleMiniQuizUpdates() {
  const miniQuiz = document.querySelector('form.mini-quiz--flex');
  if (!miniQuiz) return;
  if (miniQuiz.querySelector('[type="submit]')) return;

  miniQuiz
    .querySelector('input[type="range"]')
    .dispatchEvent(new Event('change'));
}

function handleStickyUpdates(variant, productId) {
  const stickySection = document.querySelector(
    '[data-content="sticky-cart-add"]'
  );
  if (!stickySection) return;

  const subRate = getCurrentAutoshipRate(productId);
  const offerRate = parseOfferDiscount(productId);
  const price = variant.price * subRate * offerRate;
  const quantity = parsePrefixQtySelection(productId);

  const quantityVariantLabel = stickySection.dataset.prebundleLabel
    ? ` / ${quantity} ${stickySection.dataset.prebundleLabel}${quantity > 1 ? 's' : ''}`
    : ``;

  const comparePrice = parseOptionComparePrice(variant);

  stickySection.querySelector('[data-content="variant-title"]').textContent =
    variant.title + quantityVariantLabel;
  stickySection.querySelector('[data-content="price"]').textContent =
    `$${(price * quantity * 0.01).toFixed(2)}`;
  if (comparePrice !== price) {
    stickySection.querySelector('[data-content="compare-price"]').textContent =
      `$${(comparePrice * quantity * 0.01).toFixed(2)}`;
  } else {
    stickySection.querySelector('[data-content="compare-price"]').textContent =
      ``;
  }

  const addButton = stickySection.querySelector(
    '[data-action="add-main-product"]'
  );
  if (!addButton) return;
  addButton.disabled = !variant.available;
  addButton.textContent = variant.available
    ? addButton.dataset.availableText
    : addButton.dataset.unavailableText;
}

function handleAutoshipButtonUpdates(variant, productId) {
  const button = document.querySelector(
    `input[data-content="autoship-toggle"][data-product-id="${productId}"][value="autoship"]`
  );
  if (!button) return;

  const label = button.nextElementSibling;
  if (!label) return;

  const autoshipRate = button.dataset.discountRate
    ? parseFloat(button.dataset.discountRate)
    : 1;
  const offerRate = parseOfferDiscount(productId, 'subscription');
  const comparePrice =
    variant.compare_at_price &&
    variant.compare_at_price > variant.price * offerRate * autoshipRate
      ? variant.compare_at_price
      : variant.price;
  const quantity = parsePrefixQtySelection(productId);

  const discountedPricePerItemInCents = Math.round(
    variant.price * autoshipRate * offerRate
  );
  const finalPriceInCents = discountedPricePerItemInCents * quantity;
  label.querySelector('[data-content="current-autoship-price"]').textContent =
    `$${(finalPriceInCents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const totalComparePriceInCents = comparePrice * quantity;
  const comparePriceText =
    comparePrice > variant.price * autoshipRate * offerRate
      ? `$${(totalComparePriceInCents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : '';

  const comparePriceDisplaySub = label.querySelector(
    '[data-content="compare-price"]'
  );

  const comparePriceDisplayOneTime = label.querySelector(
    '[data-one-time-compare-price]'
  );

  if (comparePriceDisplaySub) {
    comparePriceDisplaySub.textContent = comparePriceText;
  }

  if (comparePriceDisplayOneTime) {
    comparePriceDisplayOneTime.textContent = comparePriceText;
  }
}
// Updates "selected option text display"
function handleOptionContents(index, value, productId) {
  const form = document.querySelector(
    `[data-section-type="product"][data-product-id="${productId}"]`
  );
  const selector = form
    ? form.querySelector(`[data-variant-option-for="${index}"]`)
    : document.querySelector(
        `[data-variant-option-for="${index}"][data-value-product-id="${productId}"]`
      );

  if (!selector) return;
  selector.textContent = form.dataset.retitleSchema
    ? value.replace(
        form.dataset.retitleSchema.split('|||||')[0],
        form.dataset.retitleSchema.split('|||||')[1]
      )
    : value;
}

function handleSaleTagUpdates(variant, productId) {
  const variants = getProductVariants(productId);
  const parent = document.querySelector(
    `[data-section-type="product"][data-product-id="${productId}"]`
  );
  const saleTags = parent.querySelectorAll(
    '[data-savings-display]:not([data-autoship-savings])'
  );
  const autoshipRate = getCurrentAutoshipRate(productId);

  saleTags.forEach((tag) => {
    const activeVariantId = tag.hasAttribute('data-option-savings')
      ? parseInt(
          tag
            .closest('[data-corresponding-variant]')
            .getAttribute('data-corresponding-variant')
        )
      : variant.id;
    const activeVariant =
      activeVariantId === variant.id
        ? variant
        : variants.find((v) => v.id === activeVariantId);

    if (!activeVariant) return;

    const comparePrice =
      activeVariant.compare_at_price &&
      activeVariant.compare_at_price > activeVariant?.price
        ? activeVariant.compare_at_price
        : activeVariant.price;
    const discountRate =
      comparePrice > activeVariant.price * autoshipRate
        ? ((comparePrice - activeVariant.price * autoshipRate) / comparePrice) *
          100
        : 0;
    updateSaleTag(tag, discountRate);
  });
}

function parseSearchOptions(index) {
  if (index === 0) {
    return [1, 2];
  }
  if (index === 1) {
    return [0, 2];
  }
  if (index === 2) {
    return [0, 1];
  }
}

function parsePrefixQtySelection(productId) {
  const section = document.querySelector(
    `[data-section-type="product"][data-product-id="${productId}"]`
  );

  if (section.querySelector('[name="qty-prefix"]')) {
    return parseInt(section.querySelector('[name="qty-prefix"]').value);
  }
  if (section.querySelector('[name="quantity"]')) {
    return parseInt(section.querySelector('[name="quantity"]').value);
  }
  if (section.querySelector('[name="quantity"][data-fresh-quantity]')) {
    return parseInt(
      section.querySelector('[name="quantity"][data-fresh-quantity]').value
    );
  }
  return 1;
}

// Updates textcontent for each item in an array
function bulkUpdateDisplayContent(array, content) {
  array.forEach((item) => {
    item.textContent = content;
  });
}

function handleVariantIdAssignments(variant, productId, subscription = false) {
  const variants = getProductVariants(productId);
  const optionLabels = document.querySelectorAll(
    `[data-option-label][data-option-product-id="${productId}"]`
  );
  optionLabels.forEach((optionLabel) => {
    const input = document.getElementById(optionLabel.getAttribute('for'));

    if (input.checked && !subscription) {
      optionLabel.setAttribute('data-corresponding-variant', variant.id);
      updateTabSelections(input.value);
    } else {
      const optionIndex = parseInt(optionLabel.dataset.optionIndex);
      const optionValue = optionLabel.dataset.optionValue;
      const queryIndices = parseSearchOptions(optionIndex);
      const variantMatch = variants.find(
        (v) =>
          v.options[optionIndex] === optionValue &&
          v.options[queryIndices[0]] === variant.options[queryIndices[0]] &&
          v.options[queryIndices[1]] === variant.options[queryIndices[1]]
      );
      optionLabel.setAttribute('data-corresponding-variant', variantMatch?.id);
    }
  });
}

function checkSubActive(productId) {
  const subActive = document.querySelector(
    `[data-autoship-product="${productId}"][data-discount-rate]:checked`
  );
  return subActive ? true : false;
}

function parseProductApplicable(productId, offerDetails) {
  if (!offerDetails) return false;
  if (!offerDetails.item_ids || offerDetails.item_ids.length === 0) return true;
  return offerDetails.item_ids.includes(productId);
}

function parseCustomerApplicable(offerDetails) {
  if (
    customerTags &&
    customerTags.includes('Active Subscriber') &&
    !offerDetails.existing_subscribers
  )
    return false;
  return true;
}

function parseOfferDiscount(productId, type = null) {
  const offerDetails = offer ? parseOfferDetails(offer) : null;
  if (!offerDetails) return 1;

  const productApplicable = parseProductApplicable(productId, offerDetails);
  if (!productApplicable) return 1;

  const customerApplicable = parseCustomerApplicable(offerDetails);
  if (!customerApplicable) return 1;

  if (!type) {
    const subActive = checkSubActive(productId);
    if (
      subActive &&
      offerDetails.apply_ss &&
      offerDetails.apply_ss === true &&
      offerDetails.discount
    )
      return offerDetails.discount;
    if (
      !subActive &&
      offerDetails.apply_one_time &&
      offerDetails.apply_one_time === true &&
      offerDetails.discount
    )
      return offerDetails.discount;
  } else if (type === 'subscription') {
    if (
      offerDetails.apply_ss &&
      offerDetails.apply_ss === true &&
      offerDetails.discount
    )
      return offerDetails.discount;
  } else if (type === 'one_time') {
    if (
      offerDetails.apply_one_time &&
      offerDetails.apply_one_time === true &&
      offerDetails.discount
    )
      return offerDetails.discount;
  }

  return 1;
}

function getCurrentAutoshipRate(productId) {
  const subActive = document.querySelector(
    `[data-autoship-product="${productId}"][data-discount-rate]:checked`
  );
  if (subActive && subActive.dataset.discountRate) {
    return parseFloat(subActive.dataset.discountRate);
  }
  return 1;
}

function parseOptionComparePrice(variant, quantity = 1) {
  return variant.compare_at_price && variant.compare_at_price > variant.price
    ? variant.compare_at_price * quantity
    : variant.price * quantity;
}

function updateOptionPricing(label, variant, productId, quantity = 1) {
  // NEED TO ADD IN OFFER CHECKS HERE...
  const offerRate = parseOfferDiscount(productId);
  const subRate = getCurrentAutoshipRate(productId);
  const price = variant.price * subRate * quantity * offerRate;
  const comparePrice = parseOptionComparePrice(variant, quantity);

  label.querySelector('[data-content="price"]').textContent =
    `$${(price * 0.01).toFixed(2)}`;
  label.querySelector('[data-content="compare-price"]').textContent =
    comparePrice !== price ? `$${(comparePrice * 0.01).toFixed(2)}` : '';
}

function handlePriceUpdates(variant, productId) {
  const variants = getProductVariants(productId);
  const priceDisplays = document.querySelectorAll(
    `[data-variant-price-for="${productId}"]`
  );

  const comparePriceDisplays = document.querySelectorAll(
    `[data-variant-compare-price-for="${productId}"]`
  );

  priceDisplays.forEach((display) => {
    if (display.hasAttribute('data-one-time-price')) {
      const quantity = parsePrefixQtySelection(productId);
      const basePrice = variant.price * quantity;
      const offerRate = parseOfferDiscount(productId, 'one_time');
      const price = basePrice * offerRate;

      if (display.hasAttribute('data-atc-button-price')) {
        display.textContent = ` - $${(price * 0.01).toFixed(2)}`;
      } else {
        display.textContent = `$${(price * 0.01).toFixed(2)}`;
      }
      const comparePrice =
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price * quantity
          : null;

      const comparePriceDisplay = document.querySelector(
        `[data-variant-compare-price-for="${productId}"][data-one-time-compare-price]`
      );

      if (comparePriceDisplay) {
        if (comparePrice && comparePrice > price) {
          comparePriceDisplay.textContent = `$${(comparePrice * 0.01).toFixed(2)}`;
          comparePriceDisplay.style.display = '';
        } else {
          comparePriceDisplay.textContent = '';
          comparePriceDisplay.style.display = 'none';
        }
      }
    } else if (display.hasAttribute('data-prefix-qty')) {
      const quantity = parseInt(display.getAttribute('data-prefix-qty'));
      const label = display.closest('[data-qty-prefix-label]');
      const variantTitle = variant?.title?.toLowerCase();

      if (
        label &&
        variantTitle &&
        (bagAmount = parseInt(label.getAttribute('data-option-value')))
      ) {
        const totalPounds =
          bagAmount * (variantTitle.includes('small') ? 1 : 2);

        const bagAmountContainer = label.querySelector(
          '[data-content="bag-pounds"]'
        );
        if (bagAmountContainer)
          bagAmountContainer.innerHTML = `${totalPounds} lbs&nbsp;`;
      }

      updateOptionPricing(label, variant, productId, quantity);
    } else if (display.hasAttribute('data-shadow-price')) {
      const parent = display.closest('[data-shadow-input-group]');
      if (!parent) return;

      const grandparent = parent.closest('.product-single__meta');
      const selectedQuantity =
        parseInt(grandparent.querySelector('[name="quantity"]').value) || 1;

      const activeVariantId = parent.querySelector('input').dataset
        .activeVariant
        ? parseInt(parent.querySelector('input').dataset.activeVariant)
        : null;

      if (activeVariantId) {
        const activeVariant = variants.find((v) => v.id === activeVariantId);
        updateOptionPricing(parent, activeVariant, productId, selectedQuantity);
      }
    } else {
      const label = display.closest(
        '[data-option-label], [data-prefix-qty-label]'
      );
      const variantId = label?.dataset?.correspondingVariant;
      if (!variantId) return;
      const optionVariant = variants.find((v) => v.id === parseInt(variantId));
      updateOptionPricing(label, optionVariant, productId);
    }
  });
}

function getSelectedSellingPlanAllocation(variant) {
  const sellingPlanInput = document.querySelector('[data-selling-plan-input]');
  const selectedPlanId = sellingPlanInput ? parseInt(sellingPlanInput.value) : null;
  if (selectedPlanId && variant?.selling_plan_allocations) {
    const match = variant.selling_plan_allocations.find(
      a => a.selling_plan_id === selectedPlanId
    );
    if (match) return match;
  }
  return variant?.selling_plan_allocations?.[0] || null;
}

function handlePriceUpdatesWithQuantityInput(variant, productId, quantity) {
  const activeSellingPlan = getSelectedSellingPlanAllocation(variant);

  const autoshipPriceDisplays = document.querySelectorAll(
    `[data-variant-price-for="${productId}"][data-content="current-autoship-price"]`
  );
  const autoshipComparePriceDisplays = document.querySelectorAll(
    `[data-content="compare-price"]`
  );

  if (autoshipPriceDisplays.length > 0 && activeSellingPlan) {
    const discountedPrice = activeSellingPlan.price;
    const finalPrice = discountedPrice * quantity;
    autoshipPriceDisplays.forEach((display) => {
      if (display.hasAttribute('data-atc-button-price')) {
        display.textContent = ` - $${(finalPrice * 0.01).toFixed(2)}`;
      } else {
        display.textContent = `$${(finalPrice * 0.01).toFixed(2)}`;
      }
    });
  }

  if (autoshipComparePriceDisplays.length > 0 && activeSellingPlan) {
    const comparePrice =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : variant.price;

    autoshipComparePriceDisplays.forEach((display) => {
      if (comparePrice) {
        const totalComparePrice = comparePrice * quantity;
        display.textContent = `$${(totalComparePrice * 0.01).toFixed(2)}`;
      } else {
        display.textContent = '';
      }
    });
  }

  const priceDisplays = document.querySelectorAll(
    `[data-variant-price-for="${productId}"]`
  );

  priceDisplays.forEach((display) => {
    if (
      display.hasAttribute('data-content') &&
      (display.dataset.content === 'current-autoship-price' ||
        display.dataset.content === 'compare-price')
    ) {
      return;
    }

    if (display.hasAttribute('data-one-time-price')) {
      const basePrice = variant.price * quantity;
      const offerRate = parseOfferDiscount(productId, 'one_time');
      const price = basePrice * offerRate;
      if (display.hasAttribute('data-atc-button-price')) {
        display.textContent = ` - $${(price * 0.01).toFixed(2)}`;
      } else {
        display.textContent = `$${(price * 0.01).toFixed(2)}`;
      }
      const comparePrice =
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price * quantity
          : null;

      const comparePriceDisplay = document.querySelector(
        `[data-variant-compare-price-for="${productId}"][data-one-time-compare-price]`
      );

      if (comparePriceDisplay) {
        if (comparePrice && comparePrice > price) {
          comparePriceDisplay.textContent = `$${(comparePrice * 0.01).toFixed(2)}`;
          comparePriceDisplay.style.display = '';
        } else {
          comparePriceDisplay.textContent = '';
          comparePriceDisplay.style.display = 'none';
        }
      }
    } else if (display.hasAttribute('data-prefix-qty')) {
      const label = display.closest('[data-qty-prefix-label]');
      const variantTitle = variant?.title?.toLowerCase();
      const currentQuantity = quantity;

      if (
        label &&
        variantTitle &&
        (bagAmount = parseInt(label.getAttribute('data-option-value')))
      ) {
        const totalPounds =
          bagAmount * (variantTitle.includes('small') ? 1 : 2);
        const bagAmountContainer = label.querySelector(
          '[data-content="bag-pounds"]'
        );
        if (bagAmountContainer)
          bagAmountContainer.innerHTML = `${totalPounds} lbs&nbsp;`;
      }
      updateOptionPricing(label, variant, productId, currentQuantity);
    } else if (display.hasAttribute('data-shadow-price')) {
      const parent = display.closest('[data-shadow-input-group]');
      if (!parent) return;
      const selectedQuantity = quantity;
      const grandparent = parent.closest('.product-single__meta');
      const activeVariantId = parent.querySelector('input').dataset
        .activeVariant
        ? parseInt(parent.querySelector('input').dataset.activeVariant)
        : null;

      if (activeVariantId) {
        const activeVariant = variants.find((v) => v.id === activeVariantId);
        updateOptionPricing(parent, activeVariant, productId, selectedQuantity);
      }
    } else {
      const label = display.closest(
        '[data-option-label], [data-prefix-qty-label]'
      );
      const variantId = label?.dataset?.correspondingVariant;
      if (!variantId) return;
      const optionVariant = variants.find((v) => v.id === parseInt(variantId));
      updateOptionPricing(label, optionVariant, productId);
    }
  });
}

function updateSaleTag(tag, discountRate) {
  if (discountRate > 0) {
    tag.textContent = `Save ${discountRate.toFixed(0)}%`;
    tag.classList.remove('hidden');
  } else {
    tag.classList.add('hidden');
    tag.textContent = '';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const flavorButtons = document.querySelectorAll(
    '[data-flavor-input], [data-option-label][data-option-index="0"]'
  );

  flavorButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const flavorValue = this.dataset.optionValue || this.value;
      updateQuantityButtonsForFlavorValue(flavorValue);
    });
  });
});

function updateQuantityButtonsForFlavorValue(flavorValue) {
  const buttonContainer = document.querySelector('.quantity-selector-buttons');
  if (
    !buttonContainer ||
    buttonContainer.dataset.quantityMode !== 'variant-selection'
  )
    return;

  const productForm = document.querySelector('.product-single__form');
  const productId = productForm?.dataset.productid;

  if (!productId) return;

  const allVariants = getProductVariants(productId);
  const availableQuantities = new Set();

  allVariants.forEach((v) => {
    if (v.option1.toLowerCase() === flavorValue.toLowerCase() && v.available) {
      availableQuantities.add(v.option2);
    }
  });

  const buttons = buttonContainer.querySelectorAll('.quantity-button-wrapper');
  buttons.forEach((button) => {
    const input = button.querySelector('input[data-variant-input]');
    const value = input?.value;

    if (availableQuantities.has(value)) {
      button.style.display = '';
    } else {
      button.style.display = 'none';
    }
  });

  // Auto-select first available if current is hidden
  const checkedInput = buttonContainer.querySelector(
    'input[data-variant-input]:checked'
  );
  if (checkedInput && !availableQuantities.has(checkedInput.value)) {
    const firstVisibleButton = Array.from(buttons).find(
      (btn) => btn.style.display !== 'none'
    );
    if (firstVisibleButton) {
      const firstInput = firstVisibleButton.querySelector(
        'input[data-variant-input]'
      );
      if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}

document.addEventListener('variant:change', (event) => {
  const variant = event?.detail?.variant;
  if (variant) {
    handleVariantFormChange(variant);
  }
  updateOptionalVariantTitle(event);
});

function updateOptionalVariantTitle(e) {
  if (e && e.detail && e.detail.variant) {
    const variant = e.detail.variant;

    const variantTitleSpan = document.querySelector('[data-variant-title]');
    if (variantTitleSpan && variant.option1) {
      variantTitleSpan.textContent = variant.option1;
    }

    const variantDescriptionDiv = document.querySelector(
      '[data-treat-variant-description]'
    );
    if (variantDescriptionDiv && variant.option1) {
      const flavor = variant.option1.toLowerCase();
      const descriptionData =
        window.flavorDescriptions && window.flavorDescriptions[flavor];

      if (descriptionData) {
        variantDescriptionDiv.innerHTML = descriptionData;
      } else {
        variantDescriptionDiv.innerHTML = window.flavorDescriptions.product;
      }
    }

    const variantDetailsDiv = document.querySelector(
      '[data-treat-variant-details]'
    );
    if (variantDetailsDiv && variant.option1) {
      const flavor = variant.option1.toLowerCase();
      const detailsData = window.flavorDetails && window.flavorDetails[flavor];

      if (detailsData) {
        variantDetailsDiv.innerHTML = detailsData;
      } else {
        variantDetailsDiv.innerHTML = '';
      }
    }
  }
}

function initSubscriptionEvents() {
  const subscriptionToggles = document.querySelectorAll(
    'input[data-toggles="autoship"]'
  );
  if (subscriptionToggles.length === 0) return;

  subscriptionToggles.forEach((toggle) => {
    toggle.addEventListener('change', (event) =>
      handleSubscriptionToggle(event)
    );

    // Initialize select disabled state on page load based on checked radio
    if (toggle.checked) {
      const subscriptionActive = toggle.value === 'autoship';
      toggleAutoshipOptions(toggle, subscriptionActive);

      // Trigger change event on the select to ensure any dependent code runs
      if (subscriptionActive) {
        const parent = toggle.closest('[data-autoship-wrapper]');
        if (parent) {
          const select = parent.querySelector('select[data-content="shipment-frequency"]');
          if (select && !select.disabled) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  });

  const productIds = Array.from(
    new Set(Array.from(subscriptionToggles).map((t) => t.dataset.productId))
  );
  productIds.forEach((productId) => {
    const variant = parseCurrentSelection(productId);
    handleVariantIdAssignments(variant, productId, true);
    const subRate = getCurrentAutoshipRate(productId);
    if (subRate !== 1) {
      handlePriceUpdates(variant, productId);
      handleSaleTagUpdates(variant, productId);
    }

    issueAutoshipUpdateEvent(variant, productId);
  });
}

function initFixedQuantityEvents() {
  const fixedQuantityInputs = document.querySelectorAll(
    'input[name="qty-prefix"]'
  );
  if (fixedQuantityInputs.length === 0) return;

  fixedQuantityInputs.forEach((input) => {
    input.addEventListener('change', (event) =>
      handleFixedQuantityChange(event)
    );
  });

  if (offer) {
    const selected = Array.from(fixedQuantityInputs).find(
      (input) => input.checked
    );
    if (!selected) return;

    setTimeout(() => {
      selected.dispatchEvent(new Event('change'));
    }, 10);
  }
}

function handleFixedQuantityChange(event) {
  console.log('handleFixedQuantityChange');
  const productId = event.target.dataset.optionProductId;
  const variant = parseCurrentSelection(productId);

  handleOptionContents('quantity-prefix', event.target.value, productId);

  const section = document.querySelector(
    `[data-section-type="product"][data-product-id="${productId}"]`
  );
  if (section) {
    const qtyInput = section.querySelector('[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = event.target.value;
    }
    section.dispatchEvent(
      new CustomEvent('variantChange', {
        detail: {
          variant: variant
        }
      })
    );
  }
  document.dispatchEvent(
    new CustomEvent('variant:change', {
      detail: {
        variant: variant
      }
    })
  );
}

function issueAutoshipUpdateEvent(variant, productId) {
  const subRate = getCurrentAutoshipRate(productId);
  const offerRate = parseOfferDiscount(productId);
  const container = document.querySelector(
    `.pdp-2025[data-product-id="${productId}"]`
  );
  if (!container) return;
  container.dispatchEvent(
    new CustomEvent('variantPriceChange', {
      detail: {
        variant: variant,
        autoship_rate: subRate,
        offer_rate: offerRate
      }
    })
  );
}

function handleSubscriptionToggle(event) {
  if (event.target.type === 'radio') {
    handleOptionContents(
      9,
      event.target.dataset.labelValue,
      event.target.dataset.productId
    );
  }
  const productId = event.target.dataset.productId;
  const variant = parseCurrentSelection(productId);

  handleVariantFormChange(variant);
  issueAutoshipUpdateEvent(variant, productId);
  //handleSaleTagUpdates(variant, productId)
  toggleAutoshipOptions(event.target, event.target.value === 'autoship');
}

// Displays toggleable panel when applicable
function toggleAutoshipOptions(target, subscriptionActive) {
  const parent = target.closest('[data-autoship-wrapper]');
  if (!parent) return;

  const optionsPanel = parent.querySelector('[data-autoship-frequencies]');
  if (!optionsPanel) return;
  const select = optionsPanel.querySelector('select');
  select.disabled = !subscriptionActive;

  // FIX: When enabling the select, ensure a value is selected
  // If no value is selected, select the first option
  if (subscriptionActive && (!select.value || select.value === '')) {
    if (select.options.length > 0) {
      select.selectedIndex = 0;
      select.value = select.options[0].value;

      // Trigger change event to update any dependent UI
      const changeEvent = new Event('change', { bubbles: true });
      select.dispatchEvent(changeEvent);
    }
  }

  // if (select.options.length === 1) return;
  // optionsPanel.classList.toggle('hidden', !subscriptionActive)
}

function updateTabSelections(value) {
  const toggles = document.querySelectorAll(
    `[data-component="toggler"][data-toggle-for="${value.toLowerCase()}"]`
  );
  if (toggles.length === 0) return;

  toggles.forEach((toggle) => {
    toggle.click();
  });
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.classList.contains('rc-container-wrapper')) {
          node.remove();
        } else if (
          node.id === 'launcher' ||
          node.tagName === 'ACCESS-WIDGET-UI' ||
          (node.querySelector &&
            node.querySelector('.yotpo-reviews-tab-floating-tab'))
        ) {
          const nodeType =
            node.id === 'launcher'
              ? 'zendesk'
              : node.tagName === 'ACCESS-WIDGET-UI'
                ? 'acsb'
                : 'yotpo';
          updateComponentLayout(nodeType, node);
        }
      });
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

function updateComponentLayout(type, element) {
  const stickyAdd = document.querySelector('[data-content="sticky-cart-add"]');
  if (!stickyAdd) return;
  const translate = stickyAdd.offsetHeight * -1;
  if (translate === 0) return;

  if (type === 'zendesk') {
    element.style.transform = `translateY(${translate}px)`;
  } else if (type === 'yotpo') {
    const targetChild = element.querySelector(
      '.yotpo-reviews-tab-floating-tab'
    );
    if (targetChild) {
      targetChild.style.transform = `rotate(90deg) translateX(${translate}px)`;
    } else {
      element.style.transform = `rotate(90deg) translateX(${translate}px)`;
    }
  } else if (type === 'acsb') {
    if (!element.shadowRoot.querySelector('button[data-testid="acsb-trigger"]'))
      return;
    element.shadowRoot.querySelector(
      'button[data-testid="acsb-trigger"]'
    ).style.transform = `translateY(${translate}px)`;
  }
}

window.addEventListener('resize', () => {
  const zdWidget = document.getElementById('launcher');
  if (zdWidget) updateComponentLayout('zendesk', zdWidget);

  const yotpoWidget = document.querySelector('.yotpo-reviews-tab-floating-tab');
  if (yotpoWidget) updateComponentLayout('yotpo', yotpoWidget);

  const acsbWidget = document.querySelectorAll('access-widget-ui');
  if (acsbWidget.length >= 3)
    updateComponentLayout('acsb', acsbWidget[2].shadowRoot);
});

function initStickyBar() {
  const stickySection = document.querySelector(
    '[data-content="sticky-cart-add"]'
  );
  if (!stickySection) return;

  // Set initial sticky pricing, etc.
  const variant = parseCurrentSelection(stickySection.dataset.productId);
  handleStickyUpdates(variant, stickySection.dataset.productId);

  // Add event listeners
  const stickyAddButton = stickySection.querySelector(
    '[data-action="add-main-product"]'
  );
  stickyAddButton.addEventListener('click', (event) => handleStickyAdd(event));
}

function handleStickyAdd(event) {
  const productId = event.target.dataset.productId;
  const form = document.querySelector(
    `form[action="/cart/add"][data-productid="${productId}"]`
  );
  if (!form) return;

  const addToCartButton = form.querySelector('[type="submit"][name="add"]');
  addToCartButton.click();
}

function initShadowInputEvents() {
  const shadowInputs = document.querySelectorAll('[data-variant-input-shadow]');
  shadowInputs.forEach((input) => {
    input.addEventListener('change', (event) => handleShadowInputChange(event));
  });
}

function handleShadowInputChange(event) {
  const parent = event.target.closest('.product-single__meta');
  if (!parent) return;

  const options = {
    Flavor: event.target.value,
    Size: event.target.dataset.activeSize
  };

  for (const key in options) {
    const value = key === 'Flavor' ? options[key] : options[key] + 'g';
    const input = parent.querySelector(
      `input[type="radio"][name="${key}"][value="${value}"]`
    );
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change'));
    }
  }
}

function initLoadHandlers() {
  initSubscriptionEvents();
  initFixedQuantityEvents();
  initShadowInputEvents();
  handleDefaultSelection();
  initStickyBar();
  initQuantityInputs();
  initScrollListener();
  initializeFreshSelection();
  handleUtsPropUpdates();
  handleGoogleTraffic();
  initJunipCustom();
  handleColorOnVariantChange();
  initCustomRadios();
  initQuantityPresetButtons();
  initVariantInputButtonStyles();
}

function initCustomRadios() {
  const customRadioInputs = document.querySelectorAll('.custom-radio-input');

  if (customRadioInputs.length > 0) {
    customRadioInputs.forEach((input) => {
      input.addEventListener('change', function () {
        if (this.checked) {
          const name = this.getAttribute('name');
          const allInputs = document.querySelectorAll(`input[name="${name}"]`);

          allInputs.forEach((radio) => {
            const label = radio.labels?.[0];
            if (label) {
              const dot = label.querySelector('.custom-radio-dot');

              if (radio.checked) {
                radio.classList.add('checked');
                if (dot) dot.classList.remove('hidden');
              } else {
                radio.classList.remove('checked');
                if (dot) dot.classList.add('hidden');
              }
            }
          });
        }
      });
    });
  }
}

function handleColorOnVariantChange() {
  try {
    const metaobjectsElement = document.getElementById(
      'variant-metaobjects-data'
    );

    if (!metaobjectsElement) {
      console.warn('Warning: variant-metaobjects-data element not found');
      return;
    }

    const metaobjectsData = JSON.parse(metaobjectsElement.textContent);

    // Listen for variant changes
    document.addEventListener('variant:change', function (event) {
      const variantId = event?.detail?.variant?.id;
      if (!variantId) return;
      updateColorBasedOnVariant(variantId);
    });

    function updateColorBasedOnVariant(variantId) {
      const variantData = metaobjectsData[variantId];
      if (
        !variantData ||
        !variantData.nutrition ||
        !variantData.nutrition.flavor_color
      ) {
        return; // Exit if required data is missing
      }

      const mealType = variantData.options[0];
      const colorValue = variantData.nutrition.flavor_color;

      // Create the class names
      const ffdBodyClass =
        'flavor-ffd-' + mealType.replace(/[^a-z0-9]/gi, '').toLowerCase();
      const colorClass =
        'flavor-color-' + colorValue.replace(/[^a-z0-9-]/gi, '').toLowerCase();

      // Get all current classes as an array (not live collection)
      const currentClasses = Array.from(document.body.classList);

      // Remove all flavor-ffd-* and flavor-color-* classes
      currentClasses.forEach((className) => {
        if (
          className.startsWith('flavor-ffd-') ||
          className.startsWith('flavor-color-')
        ) {
          document.body.classList.remove(className);
        }
      });

      document.body.classList.add(ffdBodyClass);
      document.body.classList.add(colorClass);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const flavorButtons = document.querySelectorAll('[data-flavor-input]');

    const urlVariantId = urlParams.get('variant');

    if (urlVariantId && flavorButtons.length > 0) {
      const activeVariantOnPageLoad = metaobjectsData[urlVariantId];

      if (activeVariantOnPageLoad && activeVariantOnPageLoad.options) {
        const flavorOption = activeVariantOnPageLoad.options[0];

        flavorButtons.forEach((button) => {
          const buttonValue = button.value.toLowerCase();
          if (buttonValue === flavorOption.toLowerCase()) {
            button.checked = true;
            button.dispatchEvent(new Event('change'));
          }
        });
      }
    }

    if (!urlVariantId) {
      const firstFlavorButton = flavorButtons[0];

      if (firstFlavorButton) {
        firstFlavorButton.click();
        firstFlavorButton.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  } catch (error) {
    console.error('Error in handleColorOnVariantChange:', error);
  }
}

function initJunipCustom() {
  const appBlocks = document.querySelectorAll(
    '.shopify-block.shopify-app-block'
  );
  const junipBlocks = Array.from(appBlocks).filter((block) =>
    block.id.includes('junip')
  );

  junipBlocks.forEach((b) => {
    if (b.querySelector('.junip-product-summary-stars-wrapper')) {
      setTimeout(() => {
        const parent = b.querySelector('.junip-product-summary');
        const productId = parent.dataset.productId || '';
        const reviewSection = document.getElementById(
          `junipProductReviews${productId}`
        );
        if (reviewSection) {
          const reviewButton = reviewSection.querySelector(
            '.junip-write-review-cta'
          );
          if (reviewButton) {
            const button = document.createElement('button');
            button.classList.add('junip-write-review-inline');
            button.textContent = 'Write A Review';
            b.querySelector(
              '.junip-product-summary-star-ratings-container'
            ).appendChild(button);
            button.addEventListener('click', (event) => {
              event.preventDefault();
              reviewButton.click();
            });
          }
        }
      }, 1000);
    }
  });
}

function handleGoogleTraffic() {
  const pagesViewed = sessionStorage.getItem('sessionPageViews')
    ? parseInt(sessionStorage.getItem('sessionPageViews'))
    : 1;
  if (pagesViewed > 2) return;

  const referrer = sessionStorage.getItem('sessionReferrer');
  if (referrer && referrer.includes('google')) {
    handleGoogleTrafficUpdate();
  }
}

function handleGoogleTrafficUpdate() {
  const prefixFieldset = document.querySelector(
    'fieldset[name="quantity-prefix"]'
  );
  if (!prefixFieldset) return;

  const label = prefixFieldset.querySelector('label');
  if (label) {
    label.click();
  }
}

function initializeFreshSelection() {
  if (!document.querySelector('[data-content="fresh-mini-quiz"]')) return;

  const input = document.querySelector('[data-variant-input-shadow]');
  input.dispatchEvent(new Event('change'));

  // Hack to ensure the price is updated automatically regardless of sync issues
  setTimeout(() => {
    if (
      document.querySelector('[data-shadow-price]').textContent.trim() === ''
    ) {
      console.log('Price is not updated, re-initializing');
      initializeFreshSelection();
    }
  }, 100);
}

function handleStickyScroll(visible) {
  const stickySection = document.querySelector(
    '[data-content="sticky-cart-add"]'
  );
  if (!stickySection) return;

  const elementTranslate = visible ? stickySection.offsetHeight * -1 : 0;
  const acsbHosts = document.querySelectorAll('access-widget-ui');
  const acsbWidget =
    acsbHosts.length >= 3
      ? acsbHosts[2].shadowRoot.querySelector(
          'button[data-testid="acsb-trigger"]'
        )
      : null;
  if (acsbWidget) acsbWidget.style.transition = `transform 0.25s ease-in-out`;
  const zdWidget = document.getElementById('launcher');
  const yotpoWidget = document.querySelector('.yotpo-reviews-tab-floating-tab');

  const visibilityClasses = visible
    ? ['visible', 'transitioned']
    : ['transitioned', 'visible'];
  const delay = visible ? 25 : 275;

  stickySection.classList.toggle(visibilityClasses[0], visible);
  if (zdWidget && !visible)
    zdWidget.style.transform = `translateY(${elementTranslate}px)`;
  if (yotpoWidget && !visible)
    yotpoWidget.style.transform = `rotate(90deg) translateX(${elementTranslate}px)`;
  if (acsbWidget && !visible)
    acsbWidget.style.transform = `translateY(${elementTranslate}px)`;
  setTimeout(() => {
    stickySection.classList.add(visibilityClasses[1], visible);
    if (acsbWidget && visible)
      acsbWidget.style.transform = `translateY(${elementTranslate}px)`;
    if (zdWidget && visible)
      zdWidget.style.transform = `translateY(${elementTranslate}px)`;
    if (yotpoWidget && visible)
      yotpoWidget.style.transform = `rotate(90deg) translateX(${elementTranslate}px)`;
  }, delay);
}

function initScrollListener() {
  const productSections = document.querySelectorAll(
    '.pdp-2025[data-section-type="product"]'
  );
  if (
    productSections.length === 0 ||
    productSections.length > 1 ||
    !document.querySelector('[data-content="sticky-cart-add"]')
  )
    return;

  const mainSection = productSections[0];
  const addButton = mainSection.querySelector(
    'button[type="submit"][name="add"]'
  );
  if (!addButton) return;

  const scrollObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          // Out of view
          if (entry.boundingClientRect.top <= 0) {
            handleStickyScroll(true);
          }
        } else {
          // In view
          handleStickyScroll(false);
        }
      });
    },
    {
      root: null,
      threshold: 0 // Ensures out of view only considered when it has been scrolled past
    }
  );

  // Observe the target element
  scrollObserver.observe(addButton);
}

async function handleDefaultSelection() {
  const currentUrlParams = new URLSearchParams(window.location.search);
  if (currentUrlParams.has('variant')) return;

  const firstOptionButtons = document.querySelectorAll(
    '[data-option-index="0"] input[type="radio"]'
  );

  if (firstOptionButtons.length > 0) {
    const firstFlavorInput = firstOptionButtons[0];

    if (!firstFlavorInput.checked) {
      firstFlavorInput.checked = true;
      firstFlavorInput.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  const defaultSelections = document.querySelectorAll(
    '[data-option-preselect]'
  );
  if (defaultSelections.length === 0) return;

  const productId = parseInt(
    defaultSelections[0].closest('[data-product-id]').dataset.productId
  );
  const variants = getProductVariants(productId);

  for (let i = 0; i < defaultSelections.length; i++) {
    const selection = defaultSelections[i];
    const input = selection.previousElementSibling;
    input.checked = true;
    if (i !== defaultSelections.length - 1) {
      await new Promise((resolve) => setTimeout(resolve, 50));
    } else {
      const variant = variants.find(
        (v) => v.id === parseInt(selection.dataset.correspondingVariant)
      );
      const variantSelect = document.querySelector(
        `select[name="id"][data-productid="${productId}"]`
      );
      if (variantSelect) {
        variantSelect.value = variant.id;
      }
      const currentVariantInput = document.querySelector(
        `textarea[data-current-variant-json][data-variant-product="${productId}"]`
      );
      if (currentVariantInput) {
        currentVariantInput.value = JSON.stringify(variant);
      }
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        })
      );
    }
  }
}
function handleFfdFrequencyCustomization(variant) {
  const planSelector = document.querySelector(`select[name="selling_plan"]`);
  if (!planSelector) return;

  const defaultFrequencyId =
    variant.option3 && variant.option3.includes('6 Bags')
      ? '884899886'
      : '996573230';

  planSelector.value = defaultFrequencyId;

  const selectedFrequencyEl = document.querySelector(
    `[data-value="${defaultFrequencyId}"]`
  );

  if (selectedFrequencyEl) {
    selectedFrequencyEl.click();
    const frequencyText =
      selectedFrequencyEl.dataset.frequencyNumber +
      (Number(selectedFrequencyEl.dataset.frequencyNumber) > 1
        ? ' Weeks'
        : ' Week');
    document.querySelector('.js-meal-plan-frequent').textContent =
      frequencyText;
    document.querySelector('.js-meal-plan-cost').textContent =
      document.querySelector(
        '[data-content="current-autoship-price"]'
      ).textContent;
  }
}

function handleUtsPropUpdates() {
  const utsFields = document.querySelectorAll('[name="properties[_uts]"]');
  if (utsFields.length === 0) return;

  const utsValue = new Date().getTime();
  utsFields.forEach((field) => {
    field.value = utsValue;
  });
}

document.addEventListener('DOMContentLoaded', initLoadHandlers);
document.addEventListener('ajaxProduct:added', () => {
  handleUtsPropUpdates();
});

// document.addEventListener('product:imageCarouselInit', (event) => {
//     console.log('imageCarouselInit', event)
// })

// updateCartButton: function (evt) {
//     console.log('updateCartButton')
//     // Added to handle price display on cart button
//     const addForm = evt.target.querySelector('form[action="/cart/add"]')
//     let updateButtonHtml = false
//     let subRate = 1
//     if (addForm && addForm.dataset.priceOnButton === 'true') {
//         updateButtonHtml = true
//         const autoshipSelected = addForm.querySelector('[data-content="autoship-toggle"]:checked')
//         if (autoshipSelected) {
//             console.log('autoshipSelected', autoshipSelected)
//             subRate = autoshipSelected.dataset.discountRate ? parseFloat(autoshipSelected.dataset.discountRate) : 1
//         }
//     }

//     var variant = evt.detail.variant;
//     var cartBtn = this.container.querySelector(this.selectors.addToCart);
//     var cartBtnText = this.container.querySelector(this.selectors.addToCartText);

//     function parseCartButtonContent() {
//         const defaultText = cartBtnText.dataset.defaultText
//         if (updateButtonHtml) {
//             const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price
//             const price = variant.price * subRate
//             return `${defaultText} • <span class="option-compare--price" data-content="compare-price">${comparePrice && comparePrice > price ? '$' + (comparePrice * 0.01).toFixed(2): ''}</span> <span data-content="price">$${(price * 0.01).toFixed(2)}</span>`
//         }
//         return defaultText
//     }

//     if (variant) {
//         if (variant.available) {
//             // Available, enable the submit button and change text
//             cartBtn.classList.remove(classes.disabled);
//             cartBtn.disabled = false;
//             var defaultText = cartBtnText.dataset.defaultText;
//             cartBtnText.innerHTML = parseCartButtonContent();
//         } else {
//             // Sold out, disable the submit button and change text
//             cartBtn.classList.add(classes.disabled);
//             cartBtn.disabled = true;
//             cartBtnText.textContent = theme.strings.soldOut;
//         }
//     } else {
//         // The variant doesn't exist, disable submit button
//         cartBtn.classList.add(classes.disabled);
//         cartBtn.disabled = true;
//         cartBtnText.textContent = theme.strings.unavailable;
//     }
// },

/* ------------------------------------------------------------------------------------------------

    Calculate Portion Size

------------------------------------------------------------------------------------------------  */

let variantDataItemJson =
  document.querySelector('[data-content="variants-json"]') || null;

let flavorObjects;
let toggledVariant = '';
let toggledFlavor = '';
let recommendedPetName = '';
let recommendedPetWeight = 0;
let petJustSwitched = false;
let skipNextVariantOverride = false; // When true, selectRecommendedProduct skips bag-size changes (used when URL has ?variant=)
let lastFrequencyData = null; // Stored by handleProductRecommendation for cadence changes

const variantData = JSON.parse(variantDataItemJson?.value);
const nutritionJson = document.querySelector(
  '[data-content="variants-nutrition-json"]'
);
const variantNutrition = nutritionJson ? JSON.parse(nutritionJson.value) : null;

function getPetData(id) {
  const pets = getPets();
  return pets.find((pet) => pet.id === id) || null;
}

function getPets() {
  const storageItem = localStorage.getItem('petProfiles');
  const pets = storageItem ? JSON.parse(storageItem) : null;
  return pets ? pets.pets || [] : [];
}

function handlePetSelection(petData, options = {}) {
  if (petData) {
    petJustSwitched = true;
    recommendedPetName = petData.name || '';
    if (options.skipVariantOverride) {
      skipNextVariantOverride = true;
    }
    if (petData.ffdVariantId && !options.skipVariantOverride) {
      updateVariantById(petData.ffdVariantId);
    }
    calculateRecommendation(petData);
  } else {
    console.warn('handlePetSelection called without pet data');
  }
}

document.addEventListener('petSelection:add', (e) =>
  handlePetSelection(e.detail)
);
document.addEventListener('petSelection:edit', (e) =>
  handlePetSelection(e.detail)
);
document.addEventListener('petSelection:selected', (e) => {
  // If this event came from a frequency change (not a pet switch), don't set petJustSwitched
  if (e.detail?.forcedFrequencyWeeks) {
    calculateRecommendation(e.detail);
  } else {
    handlePetSelection(e.detail);
  }
});

// Auto-apply recommendation on page load using the last selected pet
document.addEventListener('DOMContentLoaded', () => {
  // Skip auto-recommendation when the user arrived via an explicit variant URL
  // so direct links (e.g. ?variant=...518 for 32oz) aren't overridden
  const urlHasVariant = new URLSearchParams(window.location.search).has('variant');

  const selectedPetId = localStorage.getItem('selectedPet');
  if (selectedPetId) {
    const petData = getPetData(selectedPetId);
    if (petData) {
      // Small delay to ensure variant data and quantity selector are fully initialised
      setTimeout(() => handlePetSelection(petData, { skipVariantOverride: urlHasVariant }), 300);
    }
  }

  // Signal that pdp-scripts-25.js is ready (mini quiz listens for this)
  document.dispatchEvent(new Event('pdp:scriptsReady'));
});

function parseUnitType(wrapper) {
  return {
    type: wrapper.getAttribute('data-serving-type'),
    unit: wrapper.getAttribute('data-unit-measure')
  };
}

function getVariantNutrition(id) {
  if (!variantNutrition) return;
  let data = variantNutrition.find((option) => option.id === id);
  return data;
}

function calculateRecommendation(pet) {
  const titleEl = document.querySelector('[data-product-title]');
  let isSupplement =
    titleEl &&
    titleEl.getAttribute('data-product-title').includes('Supplement');
  let isFreshMeals =
    titleEl &&
    titleEl.getAttribute('data-product-title').includes('Fresh Meal');
  if (isSupplement) return;

  let months = parseAgeMonths(pet.age);
  let baseRer = parseRer(pet.weight);
  let lifeStage = parseLifestage(months);
  let mer = parseMer(pet, lifeStage, baseRer);
  recommendedPetWeight = parseInt(pet.weight) || 0;

  // Fresh products now use the Pack Builder quiz path
  if (isFreshMeals) {
    handleFreshAmounts(mer);
    return;
  }
  document.querySelectorAll('[data-content="product-form"]').forEach((form) => {
    let serving = parseUnitType(form);
    if (serving.type === 'preset' && serving.unit === 'grams') {
      // Fresh Meal Path
      let productId = form.getAttribute('data-form-product');
      let variantId = form.getAttribute('data-current-variant');
      let nutrition = getVariantNutrition(parseInt(variantId)); // Get nutrition data specifically for flavor kcal
      let dailyGrams = mer / nutrition.kcal_gram; // Get daily gram intake requirement
      let mealGrams = dailyGrams / 2; // Calc meal gram intake requirement
      let variantSizes = parseAvailableSizes(nutrition.flavor); // Get all sizes of flavor
      let mealSize = parsePresetMealSize(mealGrams, variantSizes); // Find closest match

      setFreshSizeValue(productId, `${mealSize}g`, serving.type);
    } else {
      // FFD Path
      handleDriedAmounts(mer);
    }
  });
}

function parseVariantValues() {
  let selected = [];
  let selectedRadios = document.querySelectorAll(
    '[data-input-event="variant-option"]:checked'
  );
  selectedRadios.forEach((option) => {
    selected.push(option);
  });
  let selectedSelects = document.querySelectorAll(
    'select[data-input-event="variant-option"]'
  );
  selectedSelects.forEach((option) => {
    selected.push(option);
  });
  return selected;
}

function lookupVariantId(lookup) {
  return variantData.find((item) => {
    const checkOption = (option, key) => {
      if (lookup[key].length === 1) {
        // exact match, case insensitive
        return option && option.toLowerCase() === lookup[key][0].toLowerCase();
      } else {
        // includes all values from lookup
        return lookup[key].every(
          (val) => option && option.toLowerCase().includes(val.toLowerCase())
        );
      }
    };
    const option1Matches = checkOption(item.option1, '0');
    const option2Matches = checkOption(item.option2, '1');
    const option3Matches = checkOption(item.option3, '2');

    return option1Matches && option2Matches && option3Matches;
  });
}

function getSelectedVariant() {
  let selectedValues = {
    0: [],
    1: [],
    2: []
  };
  let values = parseVariantValues();
  values.forEach((value) => {
    let index = value.getAttribute('data-option-index');
    selectedValues[index].push(value.value);
  });
  return lookupVariantId(selectedValues);
}

function updatePricesWithQuantity(event) {
  // Handle case where function is called with non-event arguments
  if (!event || !event.target) {
    console.warn('updatePricesWithQuantity called without proper event object');
    return;
  }

  const container = event.target.closest('.js-qty__wrapper');
  if (!container) {
    console.error(
      'Quantity wrapper not found. Something is wrong with the HTML structure.'
    );
    return;
  }

  const productId = container.dataset.productId;
  const variant = parseCurrentSelection(productId);
  const quantityInput = container.querySelector('.js-qty__num');

  if (variant && productId && quantityInput && quantityInput.value) {
    handlePriceUpdatesWithQuantityInput(
      variant,
      productId,
      quantityInput.value
    );
  }
}

function initQuantityInputs() {
  const plusButton = document.querySelector('.js-qty__adjust--plus');
  const minusButton = document.querySelector('.js-qty__adjust--minus');

  if (plusButton) {
    plusButton.addEventListener('click', updatePricesWithQuantity);
  }
  if (minusButton) {
    minusButton.addEventListener('click', updatePricesWithQuantity);
  }
}

function updateUrlVariantId(variantId) {
  const currentURL = window.location.href;
  if (currentURL.includes('variant=')) {
    const newURL = currentURL.replace(/(variant=)(\d+)/, `$1${variantId}`);
    history.replaceState(null, null, newURL);
  } else {
    const separator = currentURL.includes('?') ? '&' : '?';
    const newURL = `${currentURL}${separator}variant=${variantId}`;
    history.replaceState(null, null, newURL);
  }
}

function updateFormVariantId(variantJson) {
  if (!variantJson) return;

  let productId = variantJson.featured_image
    ? variantJson.featured_image.product_id
    : parseInt(
        document
          .querySelector('[data-product-id]')
          .getAttribute('data-product-id')
      );
  if (!productId) return;

  const productForm = document.querySelector(
    `[data-content="product-form"][data-product-id="${productId}"]`
  );
  if (!productForm) return;

  productForm.setAttribute('data-current-variant', variantJson.id);
  updateUrlVariantId(variantJson.id);
}

// Rounds number to two decimal points
function parseRound(number) {
  return Math.round((number + Number.EPSILON) * 100) / 100;
}

// Returns subscription frequency value (in weeks)
// Supports both old ("Delivery every 4 weeks") and new ("FRESH – HALF LB 2 WEEKS PLAN") formats
function parseFrequency(valueString) {
  const lower = String(valueString).toLowerCase();
  const weekMatch = lower.split('week');
  if (weekMatch.length > 1) {
    const parts = weekMatch[0].trim().split(/\s+/);
    const num = parseInt(parts[parts.length - 1], 10);
    if (!isNaN(num)) return num;
  }
  // Fallback: try old format
  let frequencyString = lower.replace('delivery every ', '');
  return parseInt(frequencyString.split(' ')[0], 10);
}

// Returns frequency discount
function parseFrequencyDiscount(frequency) {
  const priceScale = {
    1: 1,
    2: 0.85,
    3: 0.8
  };
  let discountRate;
  if (frequency < 3) {
    discountRate = priceScale[frequency];
  } else {
    discountRate = priceScale[3];
  }
  return discountRate;
}

// Checks whether subscription options are currently selected
function checkSubscription(form) {
  if (form.getAttribute('data-subscription-only') === 'true') return true;

  const isSubscription = form.querySelector(
    '[data-group="subscription-options"] input[type="radio"]:checked'
  );
  if (isSubscription && isSubscription.value === 'true') {
    return true;
  }
  const checkboxSubscription = form.querySelector(
    '[data-content="autoship-toggle"]:checked'
  );
  if (checkboxSubscription) {
    return true;
  }
  return false;
}

function parseOptionPricing(selected, parent) {
  const fifteenFixedIds = ['6969058656302', '6969056002094', '6969058623534'];
  let basePrice = selected.price * 0.01;
  let quantityInput = parent.querySelector('[data-content="variant-quantity"]');
  let quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  let subscriptionSelected = checkSubscription(parent);
  let variantPrices = {
    one_time: {
      unit_price: basePrice,
      full_price: parseRound(basePrice * quantity)
    }
  };

  const form = parent.closest('[data-content="product-form"]');
  const staticDiscount = form.hasAttribute('data-static-sub-rate');

  let activeOt;
  if (offer) {
    let offerData = parseOfferDetails(offer);
    let pairedOfferData;
    if (offerData.paired_offer) {
      pairedOfferData = parseOfferDetails(offerData.paired_offer);
    }
    if (offerData.apply_one_time === true) {
      activeOt = offerData;
      variantPrices.one_time.offer_price = parseRound(
        basePrice * offerData.discount * quantity
      );
    } else if (pairedOfferData && pairedOfferData.apply_one_time === true) {
      activeOt = pairedOfferData;
      variantPrices.one_time.offer_price = parseRound(
        basePrice * pairedOfferData.discount * quantity
      );
    }
  }
  let serving = parseUnitType(parent);
  if (serving.unit === 'grams' && serving.type === 'preset') {
    // FRESH PATH
    let divisible = variantPrices.one_time.offer_price || basePrice;
    if (activeOt) {
      variantPrices.one_time.per_meal = parseRound(
        (divisible / 14) * activeOt.discount
      );
      variantPrices.one_time.per_day = parseRound(
        (divisible / 7) * activeOt.discount
      );
    } else {
      variantPrices.one_time.per_meal = parseRound(divisible / 14);
      variantPrices.one_time.per_day = parseRound(divisible / 7);
    }
  }
  const autoshipSelectEl = parent.querySelector(
    'select[data-content="shipment-frequency"]'
  );
  const sellingPlanChecked = parent.querySelector(
    '[data-content="autoship-toggle"]:checked'
  );
  let sellingPlanValue = sellingPlanChecked ? sellingPlanChecked.value : null;
  if (subscriptionSelected && autoshipSelectEl) {
    let frequencyValue = parseFrequency(autoshipSelectEl.value);
    let discountRate = fifteenFixedIds.includes(
      parent.getAttribute('data-form-product')
    )
      ? 0.85
      : staticDiscount
        ? 1
        : parseFrequencyDiscount(frequencyValue);
    let recurringPrice = basePrice * discountRate;
    let autoshipPricing = {
      unit_price: parseRound(recurringPrice * quantity)
    };
    if (serving.unit === 'grams' && serving.type === 'preset') {
      // FRESH PATH
      autoshipPricing.per_meal = parseRound(recurringPrice / 14);
      autoshipPricing.per_day = parseRound(recurringPrice / 7);
    }
    if (offer) {
      let offerData = parseOfferDetails(offer);
      if (!offerData.apply_ss) {
        if (
          offerData.paired_offer &&
          parseOfferDetails(offerData.paired_offer).apply_ss
        ) {
          offerData = parseOfferDetails(offerData.paired_offer);
        } else {
          return;
        }
      }
      autoshipPricing.intro_price = parseRound(
        basePrice * offerData.discount * quantity
      );
      // if (offerData.apply_ss === true) {
      //     autoshipPricing.intro_price = parseRound((basePrice * offerData.discount) * quantity)
      // }
    }
    variantPrices.autoship = autoshipPricing;
  } else if (sellingPlanValue) {
    //console.log('sp value found!')
  }
  return variantPrices;
}

function updateVariantById(variantId) {
  const productIdElement = document.querySelector(
    '.product-section[data-product-id]'
  );

  const flavorButtons = productIdElement.querySelectorAll(
    '.variant-input.flavor'
  );

  flavorButtons.forEach((button) => {
    const label = button.querySelector('label');
    if (
      label &&
      label.getAttribute('data-corresponding-variant') == variantId
    ) {
      label.click();
    }
  });

  if (!productIdElement) {
    console.error(
      'Error: Could not find product ID element (.product-section[data-product-id]). Cannot update variant.'
    );
    return;
  }

  // const productId = parseInt(productIdElement.getAttribute('data-product-id'));

  // const allProductVariants = getProductVariants(productId);

  // const toggledVariant = allProductVariants.find(
  //   (v) => v.id === parseInt(variantId)
  // );

  // if (toggledVariant) {
  //   const variantSelect = document.querySelector(
  //     `select[name="id"][data-productid="${productId}"]`
  //   );
  //   if (variantSelect) {
  //     variantSelect.value = toggledVariant.id;
  //     variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  //   }

  //   document.dispatchEvent(
  //     new CustomEvent('variant:change', {
  //       detail: {
  //         productId: productId,
  //         variant: toggledVariant
  //       }
  //     })
  //   );
  // } else {
  //   console.warn(
  //     `Variant with ID ${variantId} not found for product ID ${productId}. Cannot update.`
  //   );
  // }
}

function updateFlavorVariant(toggledFlavor) {
  const productIdElement = document.querySelector(
    '.product-section[data-product-id]'
  );

  const flavorButtons = productIdElement.querySelectorAll(
    '.variant-input.flavor'
  );

  flavorButtons.forEach((button) => {
    const label = button.querySelector('label');
    const labelValue = label.getAttribute('data-option-value');
    if (
      label &&
      labelValue &&
      labelValue.toLowerCase() == toggledFlavor.toLowerCase()
    ) {
      label.click();
    }
  });

  if (!productIdElement) {
    console.error(
      'Error: Could not find product ID element (.product-section[data-product-id]). Cannot update variant.'
    );
    toggledFlavor = null;
    return;
  }

  toggledFlavor = null;
}

function selectRecommendedProduct(dropdownItem, toggledFlavor = null, _variant = null, recommendedLbs = null) {
  // When the user arrived via an explicit ?variant= URL, skip the flavor
  // and bag-size overrides so the direct link lands on the correct SKU,
  // but still run the quantity recommendation below.
  const preserveUrlVariant = skipNextVariantOverride;
  if (skipNextVariantOverride) {
    skipNextVariantOverride = false;
  }

  if (!preserveUrlVariant && toggledFlavor) updateFlavorVariant(toggledFlavor);

  // Fresh product path — select 0.5 lb or 1 lb pack size
  const isFreshProduct = document.querySelector('[data-fresh-product]');
  if (isFreshProduct) {
    if (preserveUrlVariant) return;
    selectFreshRecommendedProduct(toggledFlavor, recommendedLbs, _variant);
    return;
  }

  // Try old dropdown path first
  const dropdown = document.querySelector('[data-dropdown]');
  if (dropdown) {
    if (preserveUrlVariant) return;
    const smallLabel = Array.from(
      dropdown.querySelectorAll('label[data-option-label]')
    ).find((label) => label.dataset.optionValue.includes('16 oz'));
    if (smallLabel) smallLabel.click();
    if (dropdownItem) dropdownItem.click();
    return;
  }

  // New radio button path (variant-b template)
  // 1. Select bag size based on Option B: 32oz (2 lbs) when recommendedLbs >= 4, else 16oz (1 lb)
  const sizeContainers = document.querySelectorAll('.quantity-selector-buttons[data-quantity-mode="variant-selection"]');
  let bagSizeLbs = 1; // default: 16oz = 1 lb

  if (preserveUrlVariant) {
    // Read the currently selected bag size without changing it
    for (const container of sizeContainers) {
      const checkedInput = container.querySelector('input[data-variant-input]:checked');
      if (checkedInput && checkedInput.value.toLowerCase().includes('32')) {
        bagSizeLbs = 2;
      }
      break;
    }
  } else {
    const preferLarge = recommendedLbs !== null && recommendedLbs >= 4;
    for (const container of sizeContainers) {
      const largeLabel = Array.from(container.querySelectorAll('label[data-quantity-label]'))
        .find((label) => label.dataset.quantityValue && label.dataset.quantityValue.toLowerCase().includes('32'));
      const smallLabel = Array.from(container.querySelectorAll('label[data-quantity-label]'))
        .find((label) => label.dataset.quantityValue && label.dataset.quantityValue.toLowerCase().includes('16'));

      if (preferLarge && largeLabel) {
        largeLabel.click();
        bagSizeLbs = 2;
      } else if (smallLabel) {
        smallLabel.click();
        bagSizeLbs = 1;
      } else if (largeLabel) {
        // fallback if no 16oz exists
        largeLabel.click();
        bagSizeLbs = 2;
      }
      break;
    }
  }

  // 2. Inject a custom recommendation quantity button alongside the 1/3/6 presets
  if (recommendedLbs !== null) {
    const exactQty = Math.ceil(recommendedLbs / bagSizeLbs);
    // Target the quantity preset container specifically (not the bag-size variant selector)
    const allQtyContainers = document.querySelectorAll('.quantity-selector-buttons:not([data-quantity-mode])');
    const presetContainer = Array.from(allQtyContainers).find(
      (el) => el.querySelector('[data-quantity-preset]')
    );

    if (presetContainer) {
      const badgeText = recommendedPetName ? `FOR ${recommendedPetName.toUpperCase()}!` : 'FOR YOU!';
      const badgeClass = 'font-dmsans leading-[112%] text-center w-[60px] bg-[#C6F432] py-[4px] rounded text-[9px] md:text-[10px] font-bold';

      // Clear any stale pet badges from static preset buttons before applying the new recommendation
      presetContainer.querySelectorAll('.quantity-button-wrapper:not([data-quantity-recommendation]) [data-pet-badge]')
        .forEach((el) => el.remove());

      // Check if a static preset button already has this exact quantity
      const staticWrapper = Array.from(
        presetContainer.querySelectorAll('.quantity-button-wrapper:not([data-quantity-recommendation])')
      ).find((w) => {
        const inp = w.querySelector('[data-quantity-preset]');
        return inp && parseInt(inp.getAttribute('data-quantity-value'), 10) === exactQty;
      });

      if (staticWrapper) {
        // Remove any previously injected button (different qty from before)
        const prevInjected = presetContainer.querySelector('[data-quantity-recommendation]');
        if (prevInjected) prevInjected.remove();

        // Update or add the "FOR PET" badge on the existing static button
        let existingBadge = staticWrapper.querySelector('[data-pet-badge]');
        if (existingBadge) {
          existingBadge.textContent = badgeText;
        } else {
          const badge = document.createElement('div');
          badge.className = badgeClass;
          badge.setAttribute('data-pet-badge', '');
          badge.textContent = badgeText;
          staticWrapper.appendChild(badge);
        }

        // Select it via the existing preset system
        const staticInput = staticWrapper.querySelector('[data-quantity-preset]');
        if (staticInput) staticInput.click();

        return; // No need to inject a new button
      }

      // Check if the previously injected button already has the correct quantity
      const existingInjected = presetContainer.querySelector('[data-quantity-recommendation]');
      if (existingInjected) {
        const existingInput = existingInjected.querySelector('[data-quantity-preset]');
        if (existingInput && parseInt(existingInput.getAttribute('data-quantity-value'), 10) === exactQty) {
          // Same quantity — just update the badge text and re-select
          const existingBadge = existingInjected.querySelector('[data-pet-badge]');
          if (existingBadge) existingBadge.textContent = badgeText;
          const allPresetLabels = presetContainer.querySelectorAll('[data-quantity-label]');
          const unitPrices = storeInitialUnitPrices();
          handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
          return;
        }
        // Different quantity — remove old injected button and fall through to inject new one
        existingInjected.remove();
      }

      // Build the new button wrapper to match quantity-selector-buttons.liquid structure
      const productId = presetContainer.closest('[data-product-id]')?.dataset.productId
        || document.querySelector('[data-section-type="product"]')?.dataset.productId
        || 'rec';

      const inputId = `qty-rec-${productId}-${exactQty}`;

      const wrapper = document.createElement('div');
      wrapper.className = 'quantity-button-wrapper relative flex flex-col rounded-lg gap-[4px]';
      wrapper.setAttribute('data-quantity-recommendation', '');

      const radioContainer = document.createElement('div');
      radioContainer.className = 'custom-radio-container flex items-center w-full justify-center';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `quantity-preset-${productId}`;
      input.setAttribute('data-quantity-preset', '');
      input.id = inputId;
      input.value = String(exactQty);
      input.tabIndex = -1;
      input.className = 'sr-only custom-radio-input checked';
      input.setAttribute('data-quantity-value', String(exactQty));
      input.checked = true;

      const label = document.createElement('label');
      label.htmlFor = inputId;
      label.className =
        'quantity-preset-label custom-radio-label w-[60px] h-[60px] cursor-pointer flex flex-col items-center rounded-lg justify-center transition-all duration-200 text-white bg-[#002B54]';
      label.setAttribute('data-quantity-label', '');
      label.setAttribute('data-quantity-value', String(exactQty));
      label.tabIndex = 0;
      label.setAttribute('onkeydown', "if(event.key==='Enter'||event.key===' '){event.preventDefault();this.click();}");

      const span = document.createElement('span');
      span.className = 'font-dmsans text-xs md:text-sm font-bold whitespace-nowrap';
      span.textContent = `${exactQty} BAG${exactQty !== 1 ? 'S' : ''}`;

      label.appendChild(span);
      radioContainer.appendChild(input);
      radioContainer.appendChild(label);
      wrapper.appendChild(radioContainer);

      // Badge below button
      const badge = document.createElement('div');
      badge.className = badgeClass;
      badge.setAttribute('data-pet-badge', '');
      badge.textContent = badgeText;
      wrapper.appendChild(badge);

      presetContainer.appendChild(wrapper);

      // Wire up change event and trigger immediately
      const allPresetLabels = presetContainer.querySelectorAll('[data-quantity-label]');
      const unitPrices = storeInitialUnitPrices();

      input.addEventListener('change', () => {
        if (input.checked) {
          handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
        }
      });

      // Deselect other presets visually and trigger the new one
      handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
    }
  }
}

function selectFreshRecommendedProduct(toggledFlavor, recommendedLbs, resolvedVariant) {
  const HALF_LB = 0.5;
  const ONE_LB = 1;

  // Determine pack size based on dog weight: >= 40 lb → 1 lb packs, else 0.5 lb
  const petWeight = recommendedPetWeight || 0;
  const packSizeLbs = petWeight >= 40 ? ONE_LB : HALF_LB;

  // Select the pack size via variant radio buttons
  const sizeContainers = document.querySelectorAll(
    '.quantity-selector-buttons[data-quantity-mode="variant-selection"]'
  );

  if (sizeContainers.length === 0) {
    // Size selectors are hidden (hide_fresh_selectors) — select variant directly
    selectFreshVariantDirectly(packSizeLbs, HALF_LB, resolvedVariant, recommendedLbs);
    return;
  }

  for (const container of sizeContainers) {
    const allLabels = Array.from(
      container.querySelectorAll('label[data-quantity-label]')
    );
    // Find the label matching our target pack size
    const targetLabel = allLabels.find((label) => {
      const val = label.dataset.quantityValue;
      if (!val) return false;
      const valLower = val.toLowerCase().replace(/\s/g, '');
      if (packSizeLbs === HALF_LB) {
        return valLower.includes('0.5') || valLower.includes('half');
      }
      return (
        (valLower.includes('1') && valLower.includes('lb') && !valLower.includes('0.5')) ||
        valLower === '1lb'
      );
    });
    if (targetLabel) {
      targetLabel.click();
    } else if (allLabels.length > 0) {
      // Fallback: select the first available lb option
      allLabels[0].click();
    }
    break;
  }

  // Calculate delivery quantity (2-week supply)
  if (recommendedLbs !== null) {
    const exactQty = Math.ceil(recommendedLbs / packSizeLbs);
    const allQtyContainers = document.querySelectorAll(
      '.quantity-selector-buttons:not([data-quantity-mode])'
    );
    const presetContainer = Array.from(allQtyContainers).find((el) =>
      el.querySelector('[data-quantity-preset]')
    );

    if (presetContainer) {
      const badgeText = recommendedPetName
        ? `FOR ${recommendedPetName.toUpperCase()}!`
        : 'FOR YOU!';
      const badgeClass =
        'font-dmsans leading-[112%] text-center w-[60px] bg-[#C6F432] py-[4px] rounded text-[9px] md:text-[10px] font-bold';

      // Clear stale pet badges
      presetContainer
        .querySelectorAll(
          '.quantity-button-wrapper:not([data-quantity-recommendation]) [data-pet-badge]'
        )
        .forEach((el) => el.remove());

      // Check if a static preset already matches
      const staticWrapper = Array.from(
        presetContainer.querySelectorAll(
          '.quantity-button-wrapper:not([data-quantity-recommendation])'
        )
      ).find((w) => {
        const inp = w.querySelector('[data-quantity-preset]');
        return (
          inp &&
          parseInt(inp.getAttribute('data-quantity-value'), 10) === exactQty
        );
      });

      if (staticWrapper) {
        const prevInjected = presetContainer.querySelector(
          '[data-quantity-recommendation]'
        );
        if (prevInjected) prevInjected.remove();

        let existingBadge = staticWrapper.querySelector('[data-pet-badge]');
        if (existingBadge) {
          existingBadge.textContent = badgeText;
        } else {
          const badge = document.createElement('div');
          badge.className = badgeClass;
          badge.setAttribute('data-pet-badge', '');
          badge.textContent = badgeText;
          staticWrapper.appendChild(badge);
        }

        const staticInput = staticWrapper.querySelector('[data-quantity-preset]');
        if (staticInput) staticInput.click();
        return;
      }

      // Remove previously injected recommendation button if different qty
      const existingInjected = presetContainer.querySelector(
        '[data-quantity-recommendation]'
      );
      if (existingInjected) {
        const existingInput = existingInjected.querySelector(
          '[data-quantity-preset]'
        );
        if (
          existingInput &&
          parseInt(existingInput.getAttribute('data-quantity-value'), 10) ===
            exactQty
        ) {
          const existingBadge = existingInjected.querySelector('[data-pet-badge]');
          if (existingBadge) existingBadge.textContent = badgeText;
          const allPresetLabels = presetContainer.querySelectorAll(
            '[data-quantity-label]'
          );
          const unitPrices = storeInitialUnitPrices();
          handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
          return;
        }
        existingInjected.remove();
      }

      // Inject new recommendation button
      const productId =
        presetContainer.closest('[data-product-id]')?.dataset.productId ||
        document.querySelector('[data-section-type="product"]')?.dataset
          .productId ||
        'rec';
      const inputId = `qty-rec-${productId}-${exactQty}`;

      const wrapper = document.createElement('div');
      wrapper.className =
        'quantity-button-wrapper relative flex flex-col rounded-lg gap-[4px]';
      wrapper.setAttribute('data-quantity-recommendation', '');

      const radioContainer = document.createElement('div');
      radioContainer.className =
        'custom-radio-container flex items-center w-full justify-center';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `quantity-preset-${productId}`;
      input.setAttribute('data-quantity-preset', '');
      input.id = inputId;
      input.value = String(exactQty);
      input.tabIndex = -1;
      input.className = 'sr-only custom-radio-input checked';
      input.setAttribute('data-quantity-value', String(exactQty));
      input.checked = true;

      const label = document.createElement('label');
      label.htmlFor = inputId;
      label.className =
        'quantity-preset-label custom-radio-label w-[60px] h-[60px] cursor-pointer flex flex-col items-center rounded-lg justify-center transition-all duration-200 text-white bg-[#002B54]';
      label.setAttribute('data-quantity-label', '');
      label.setAttribute('data-quantity-value', String(exactQty));
      label.tabIndex = 0;
      label.setAttribute(
        'onkeydown',
        "if(event.key==='Enter'||event.key===' '){event.preventDefault();this.click();}"
      );

      const span = document.createElement('span');
      span.className = 'font-dmsans text-xs md:text-sm font-bold whitespace-nowrap';
      span.textContent = `${exactQty} PACK${exactQty !== 1 ? 'S' : ''}`;

      label.appendChild(span);
      radioContainer.appendChild(input);
      radioContainer.appendChild(label);
      wrapper.appendChild(radioContainer);

      const badge = document.createElement('div');
      badge.className = badgeClass;
      badge.setAttribute('data-pet-badge', '');
      badge.textContent = badgeText;
      wrapper.appendChild(badge);

      presetContainer.appendChild(wrapper);

      const allPresetLabels = presetContainer.querySelectorAll(
        '[data-quantity-label]'
      );
      const unitPrices = storeInitialUnitPrices();

      input.addEventListener('change', () => {
        if (input.checked) {
          handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
        }
      });

      handleQuantityPresetChange(exactQty, unitPrices, allPresetLabels);
    }
  }
}

/**
 * Direct variant selection for Fresh products when size/quantity buttons are hidden.
 * Uses the pre-resolved variant from handleProductRecommendation, or falls back to
 * finding the matching variant by current flavor + target pack size.
 */
function selectFreshVariantDirectly(packSizeLbs, HALF_LB, resolvedVariant, recommendedLbs) {
  const productSection = document.querySelector('.product-section[data-product-id]');
  if (!productSection) return;

  const productId = productSection.getAttribute('data-product-id');
  let matchingVariant = resolvedVariant || null;

  // If no pre-resolved variant, look it up from product variants
  if (!matchingVariant) {
    const variants = getProductVariants(productId);
    if (!variants || variants.length === 0) return;

    const checkedFlavor = document.querySelector(
      'input[data-variant-input][data-index="option1"]:checked'
    );
    const currentFlavor = checkedFlavor ? checkedFlavor.value : null;

    matchingVariant = variants.find((v) => {
      if (!v.available) return false;
      const skuLower = (v.sku || '').toLowerCase();
      if (!skuLower.includes('single')) return false;
      // Match size from SKU: "halflb" → 0.5lb, "1lb" → 1lb
      const sizeMatch = packSizeLbs === HALF_LB
        ? skuLower.includes('halflb') || skuLower.includes('half-lb')
        : (skuLower.includes('1lb') || skuLower.includes('1-lb')) && !skuLower.includes('halflb');
      if (!sizeMatch) return false;
      if (currentFlavor && v.option1.toLowerCase() !== currentFlavor.toLowerCase()) return false;
      return true;
    });
  }

  if (!matchingVariant) return;

  // Update the hidden select element
  const selectElement = document.querySelector(
    `select[name="id"][data-productid="${productId}"]`
  );
  if (selectElement) {
    selectElement.value = matchingVariant.id;
  }

  // Calculate and set quantity (number of packs for 2-week supply)
  if (recommendedLbs !== null) {
    const exactQty = Math.ceil(recommendedLbs / packSizeLbs);
    updateQuantityInput(exactQty);

    // Update price displays to reflect total (unit price × quantity)
    const unitPrices = storeInitialUnitPrices();

    // Dispatch variant:change first so unit prices get set by handlePriceUpdates
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: { variant: matchingVariant }
      })
    );

    // Then recalculate with quantity after a tick so price elements are updated
    setTimeout(() => {
      const freshUnitPrices = storeInitialUnitPrices();
      updatePriceDisplays(exactQty, freshUnitPrices);
      triggerPriceRecalculation(exactQty);
    }, 50);
  } else {
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: { variant: matchingVariant }
      })
    );
  }

  // Also dispatch on the section for variantChange listeners
  productSection.dispatchEvent(
    new CustomEvent('variantChange', {
      detail: { variant: matchingVariant }
    })
  );

  issueAutoshipUpdateEvent(matchingVariant, productId);
}

function filterPDPFrequencyOptions(packSizeLbs, validFreshIndices, frequencyData, selectedWeeks) {
  const dropdown = document.querySelector('[data-custom-dropdown]');
  if (!dropdown) return;

  const packSizeAttr = packSizeLbs === 0.5 ? 'half' : '1lb';
  const options = dropdown.querySelectorAll('.dropdown-option');
  const selectOptions = dropdown.closest('.variant-input')
    ?.querySelectorAll('select option');
  const hiddenInput = dropdown.closest('.variant-input')
    ?.querySelector('[data-selling-plan-input]');
  const displaySpan = dropdown.querySelector('[data-selected-frequency]');

  // Build set of valid week values from validFreshIndices
  const validWeeks = validFreshIndices
    ? new Set(validFreshIndices.map(idx => parseInt(frequencyData[idx].weeks)))
    : null;

  let firstVisibleOption = null;
  let selectedOption = null;

  options.forEach(opt => {
    const optPackSize = opt.getAttribute('data-pack-size');
    const optWeeks = parseInt(opt.getAttribute('data-frequency-number'));
    const packSizeMatch = !optPackSize || optPackSize === 'unknown' || optPackSize === packSizeAttr;
    const cadenceMatch = !validWeeks || validWeeks.has(optWeeks);
    const visible = packSizeMatch && cadenceMatch;

    opt.closest('li').style.display = visible ? '' : 'none';

    if (visible && !firstVisibleOption) firstVisibleOption = opt;
    if (visible && optWeeks === selectedWeeks) selectedOption = opt;
  });

  // Also filter the hidden <select> options
  if (selectOptions) {
    selectOptions.forEach(opt => {
      const optPackSize = opt.getAttribute('data-pack-size');
      const optWeeks = parseInt(opt.getAttribute('data-option-frequency'));
      const packSizeMatch = !optPackSize || optPackSize === 'unknown' || optPackSize === packSizeAttr;
      const cadenceMatch = !validWeeks || validWeeks.has(optWeeks);
      opt.style.display = (packSizeMatch && cadenceMatch) ? '' : 'none';
    });
  }

  // Auto-select: prefer selectedWeeks, fall back to first visible
  const toSelect = selectedOption || firstVisibleOption;
  if (toSelect) {
    if (displaySpan) displaySpan.textContent = toSelect.getAttribute('data-frequency');
    const planId = toSelect.getAttribute('data-value');
    const selectEl = dropdown.closest('.variant-input')?.querySelector('select');
    if (selectEl) selectEl.value = planId;
    if (hiddenInput) hiddenInput.value = planId;
    options.forEach(o => o.classList.remove('selected'));
    toSelect.classList.add('selected');

    // Trigger price recalculation so ATC and autoship prices reflect the selected plan
    const quantityInput = document.querySelector('[name="quantity"]');
    const qty = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    triggerPriceRecalculation(qty);
  }
}

function filterModalFrequencyOptions(validFreshIndices, frequencyData, selectedWeeks, packSizeLbs) {
  const container = document.querySelector('#meal-plan-frequency-container');
  if (!container) return;

  const options = container.querySelectorAll('.select-option');
  const hiddenInput = container.querySelector('input[type="hidden"]');
  const displayText = container.querySelector('.select-text');

  if (!validFreshIndices) {
    // Not a fresh product — show all options
    options.forEach((opt) => (opt.style.display = ''));
    return;
  }

  // Build set of valid week values
  const validWeeks = new Set(
    validFreshIndices.map((idx) => parseInt(frequencyData[idx].weeks))
  );

  const packSizeAttr = packSizeLbs === 0.5 ? 'half' : (packSizeLbs === 1 ? '1lb' : null);

  options.forEach((opt) => {
    const weekVal = parseInt(opt.getAttribute('data-value'));
    const optPackSize = opt.getAttribute('data-pack-size');
    const packSizeMatch = !packSizeAttr || !optPackSize || optPackSize === 'unknown' || optPackSize === packSizeAttr;
    const cadenceMatch = validWeeks.has(weekVal);
    opt.style.display = (packSizeMatch && cadenceMatch) ? '' : 'none';
  });

  // Update the selected value to match the recommended cadence
  if (selectedWeeks && hiddenInput) {
    hiddenInput.value = selectedWeeks;
    const selectedOption = Array.from(options).find(
      (opt) => parseInt(opt.getAttribute('data-value')) === selectedWeeks
    );
    if (selectedOption && displayText) {
      displayText.textContent = selectedOption.textContent.trim();
    }
  }
}

function handleModalRecommendations(
  size,
  frequency,
  _dropdownItem,
  flavor,
  dailyServingSize,
  variant,
  isFresh
) {
  const mealPlanModalWrapper = document.querySelector('#mealPlanModalWrapper');
  if (!mealPlanModalWrapper) return;

  const sizeField = mealPlanModalWrapper.querySelector('.js-meal-plan-size');
  const bagsField = mealPlanModalWrapper.querySelector('.js-meal-plan-bags');
  const dailySizeField = mealPlanModalWrapper.querySelector(
    '.js-meal-plan-size-daily'
  );
  const frequencyField = mealPlanModalWrapper.querySelector(
    '.js-meal-plan-frequent'
  );
  const frequencySelector = document.querySelector('#meal-plan-frequency');
  const priceField = mealPlanModalWrapper.querySelector('.js-meal-plan-cost');
  const costPerDayField = mealPlanModalWrapper.querySelector('.js-meal-plan-cost-per-day');
  // -------------------------------
  // Flavor selector logic
  // -------------------------------
  if (flavor) {
    const flavorSelector = document.querySelector('#mealPlanFlavorSelector');
    if (flavorSelector) {
      const flavorInput = flavorSelector.querySelector(
        `input[value="${flavor.toLowerCase()}"]`
      );
      if (flavorInput && !flavorInput.checked) {
        flavorInput.checked = true;
        // Update active state on labels
        const allLabels = flavorSelector.querySelectorAll('label');
        allLabels.forEach(label => label.classList.remove('active'));
        const selectedLabel = flavorInput.nextElementSibling;
        if (selectedLabel) {
          selectedLabel.classList.add('active');
        }
      }
    }
  }

  // -------------------------------
  // Product type label
  // -------------------------------
  const productLabel = mealPlanModalWrapper.querySelector('.js-meal-plan-product');
  if (productLabel) {
    productLabel.textContent = isFresh ? 'Fresh Meals' : 'Freeze Dried Raw';
  }

  // -------------------------------
  // Frequency & size display
  // -------------------------------
  if (frequencyField) frequencyField.textContent = `${frequency.weeks} Weeks`;

  // Update frequency selector if it exists
  if (frequencySelector && frequency.weeks) {
    frequencySelector.value = frequency.weeks;
    frequencySelector.dispatchEvent(new Event('input'));
  }

  if (sizeField) sizeField.textContent = `${size} lbs`;

  // -------------------------------
  // Daily serving display
  // -------------------------------
  if (dailySizeField) {
    if (isFresh) {
      const cupDensity = getFreshCupDensity(flavor);
      const dailyGrams = dailyServingSize * 453.592; // lbs → grams
      const dailyCupsExact = dailyGrams / cupDensity.grams_per_cup;
      const dailyOzExact = dailyCupsExact * cupDensity.oz_per_cup;
      const dailyCupsRounded = roundToFractionCups(dailyCupsExact);
      const cupFraction = formatCupsFraction(dailyCupsRounded);
      dailySizeField.textContent = `${dailyOzExact.toFixed(1)} oz (~${cupFraction})`;
    } else {
      let [wholeNumber, fractional] = String(dailyServingSize).split('.');
      let displayAmount = wholeNumber !== '0' ? wholeNumber : '';
      if (fractional) {
        let [numerator, denominator] = parseFractionCups(fractional).split('/');
        displayAmount += ` ${numerator}/${denominator}`;
      }
      dailySizeField.textContent = `${displayAmount} ${
        dailyServingSize <= 1 ? 'cup' : 'cups'
      }`;
    }
  }

  // -------------------------------
  // Packs per day display (fresh only)
  // -------------------------------
  const packsRow = mealPlanModalWrapper.querySelector('.js-meal-plan-packs-row');
  const packsField = mealPlanModalWrapper.querySelector('.js-meal-plan-packs-daily');
  if (packsRow && packsField) {
    if (isFresh && dailyServingSize) {
      // dailyServingSize is fresh_daily_lbs; derive packs/day from variant pack size
      // We need the pack size which we'll get from the variant below, so compute after
      packsRow.style.display = '';
    } else {
      packsRow.style.display = 'none';
    }
  }

  if (!variant || !priceField) return;

  // Derive lbs per pack from variant option2
  const option2 = (variant.option2 || '').toLowerCase();
  let lbsPerPack, packLabel;
  if (isFresh) {
    const isHalfLb = option2.includes('0.5') || option2.includes('half');
    lbsPerPack = isHalfLb ? 0.5 : 1;
    packLabel = isHalfLb ? '0.5lb' : '1lb';
  } else {
    lbsPerPack = option2.includes('32') ? 2 : 1;
    packLabel = option2.includes('32') ? '32oz' : '16oz';
  }
  const quantity = Math.ceil(size / lbsPerPack);

  // -------------------------------
  // Bags/packs display
  // -------------------------------
  if (bagsField) {
    if (isFresh) {
      const packText = quantity === 1 ? 'pack' : 'packs';
      bagsField.textContent = `${quantity}, ${packLabel} ${packText}`;
    } else {
      const bagText = quantity === 1 ? 'bag' : 'bags';
      bagsField.textContent = `${quantity}, ${packLabel} ${bagText}`;
    }
  }

  // Update packs per day for fresh
  if (isFresh && packsField && dailyServingSize) {
    const dailyPacks = dailyServingSize / lbsPerPack;
    // Round to nearest quarter-pack for clean display, matching spreadsheet recommendations
    const roundedPacks = (Math.round(dailyPacks * 4) / 4).toFixed(2).replace(/\.?0+$/, '');
    const packText = parseFloat(roundedPacks) === 1 ? 'pack' : 'packs';
    packsField.textContent = `~${roundedPacks} ${packText} (${packLabel})`;
  }

  const activeSellingPlan = variant?.selling_plan_allocations?.[0];
  const weeksInFrequency = parseInt(frequency.weeks);
  const daysInFrequency = weeksInFrequency * 7;

  if (activeSellingPlan) {
    // price is per bag, so multiply by number of bags only
    const discountedPrice = activeSellingPlan.price * quantity;
    const comparePrice = activeSellingPlan.compare_at_price
      ? activeSellingPlan.compare_at_price * quantity
      : null;

    let html = `$${(discountedPrice * 0.01).toFixed(2)}`;
    if (comparePrice) {
      html += ` <span class="line-through opacity-65">$${(
        comparePrice * 0.01
      ).toFixed(2)}</span>`;
    }
    priceField.innerHTML = html;

    // -------------------------------
    // Cost per day calculation
    // -------------------------------
    if (costPerDayField && daysInFrequency > 0) {
      const costPerDay = (discountedPrice * 0.01) / daysInFrequency;
      costPerDayField.textContent = `$${costPerDay.toFixed(2)}`;
    }
  } else {
    const basePrice = variant.price * quantity;
    priceField.textContent = `$${(basePrice * 0.01).toFixed(2)}`;

    // -------------------------------
    // Cost per day calculation (one-time purchase)
    // -------------------------------
    if (costPerDayField && daysInFrequency > 0) {
      const costPerDay = (basePrice * 0.01) / daysInFrequency;
      costPerDayField.textContent = `$${costPerDay.toFixed(2)}`;
    }
  }
}

function updatePetProfileWithMealType(flavor, variantId) {
  const selectedPetId = localStorage.getItem('selectedPet');
  const petObject = getPetData(selectedPetId);

  petObject.ffdFlavor = flavor;
  petObject.ffdVariantId = flavorObjects[flavor][1];

  const petProfiles = JSON.parse(
    localStorage.getItem('petProfiles') || '{"pets":[]}'
  );
  const petIndex = petProfiles.pets.findIndex(
    (pet) => pet.id === selectedPetId
  );
  if (petIndex !== -1) {
    petProfiles.pets[petIndex] = petObject;
    localStorage.setItem('petProfiles', JSON.stringify(petProfiles));
  }
}

function updatePetProfileWithFrequency(frequencyWeeks) {
  const selectedPetId = localStorage.getItem('selectedPet');
  if (!selectedPetId) return;

  const petProfiles = JSON.parse(
    localStorage.getItem('petProfiles') || '{"pets":[]}'
  );
  const petIndex = petProfiles.pets.findIndex(
    (pet) => pet.id === selectedPetId
  );

  if (petIndex !== -1) {
    petProfiles.pets[petIndex].ffdFrequencyWeeks = frequencyWeeks;
    localStorage.setItem('petProfiles', JSON.stringify(petProfiles));
  }
}

function groupIdsByFlavor(amounts) {
  const result = {};
  Object.values(amounts).forEach((item) => {
    const flavor = item.flavor_nutrition.flavor.toLowerCase();
    const id = item.flavor_nutrition.id;
    if (!result[flavor]) result[flavor] = [];
    result[flavor].push(id);
  });
  return result;
}

function handleProductRecommendation(amounts) {
  const cupsPerPound = 6;
  const frequencySelectors = document.querySelectorAll(
    '[data-frequency-selector]'
  );

  flavorObjects = groupIdsByFlavor(amounts);

  const frequencyAmountInDays = Array.from(frequencySelectors).map(
    (element) => {
      const shippingFrequencyInWeeks = element.getAttribute(
        'data-frequency-number'
      );
      if (shippingFrequencyInWeeks) {
        return parseInt(shippingFrequencyInWeeks) * 7;
      }
    }
  );

  const form = document.querySelector('[data-content="product-form"]');
  let variantId = form.getAttribute('data-current-variant');

  const mealRecommendationAndFrequencyData = [];

  // If the current variant has no nutrition data (e.g. Trial size), fall back
  // to the first available variant of the same flavor that does.
  if (!amounts[variantId]) {
    const fallback = Object.values(amounts).find(
      (item) => item.flavor_nutrition && item.flavor_nutrition.kcal_gram
    );
    if (fallback) {
      variantId = String(fallback.flavor_nutrition.id);
    }
  }

  // Get the current pet's saved preferences
  const selectedPetId = localStorage.getItem('selectedPet');
  const petData = getPetData(selectedPetId);

  let flavorHandle = null;
  // Use saved flavor from pet profile if available, otherwise use current variant flavor
  if (petData?.ffdFlavor) {
    flavorHandle = petData.ffdFlavor.toLowerCase();
  } else if (amounts[variantId]) {
    flavorHandle = amounts[variantId]?.flavor_nutrition?.flavor;
  }
  if (flavorHandle) flavorHandle = flavorHandle.toLowerCase();

  if (!amounts[variantId]) return;

  const isFreshProduct = !!amounts[variantId].fresh_daily_lbs;
  const dailyServingSize = isFreshProduct
    ? amounts[variantId].fresh_daily_lbs
    : amounts[variantId].meal_cups_rounded * 2;

  frequencyAmountInDays.forEach((days) => {
    let amountInLbs;
    if (isFreshProduct) {
      const packSize = amounts[variantId].fresh_pack_size_lbs || 0.5;
      const MIN_PACKS = 14;
      const maxPacks = packSize === 1 ? 34 : 42;
      let packs = Math.ceil(amounts[variantId].fresh_daily_lbs * days / packSize);
      packs = Math.max(MIN_PACKS, Math.min(maxPacks, packs));
      amountInLbs = packs * packSize;
    } else {
      amountInLbs = Math.ceil(
        (days * amounts[variantId].meal_cups_rounded * 2) / cupsPerPound
      );
    }
    const frequencyObj = {
      weeks: days / 7,
      amountInLbs: amountInLbs
    };
    mealRecommendationAndFrequencyData.push(frequencyObj);
  });

  // Check if modal is open
  const builderModal = document.querySelector('#dogBuilderModal');
  const mealPlanModal = document.querySelector('#dogMealPlanModal');
  const isMealRecModalOpen =
    (builderModal && builderModal.classList.contains('modal-open')) ||
    (mealPlanModal && mealPlanModal.classList.contains('modal-open'));

  // Get saved frequency preference (petData already loaded above)
  const savedFrequencyWeeks = petData?.ffdFrequencyWeeks;

  // Check if user has selected a custom frequency in the modal
  const frequencySelector = document.querySelector('#meal-plan-frequency');
  let selectedFrequencyIndex = 0;
  let selectedFrequencyWeeks = null;

  // Compute valid cadence indices for fresh products
  let validFreshIndices = null;
  if (isFreshProduct && amounts[variantId].fresh_daily_lbs) {
    const packSize = amounts[variantId].fresh_pack_size_lbs || 0.5;
    const dailyLbs = amounts[variantId].fresh_daily_lbs;
    const dailyPacks = dailyLbs / packSize;
    const freshMinPacks = 14;
    const freshMaxPacks = packSize === 1 ? 34 : 42;

    validFreshIndices = [];
    mealRecommendationAndFrequencyData.forEach((freq, idx) => {
      const weeks = parseInt(freq.weeks);
      const naturalPacks = Math.ceil(dailyPacks * weeks * 7);
      if (naturalPacks >= freshMinPacks && naturalPacks <= freshMaxPacks) {
        validFreshIndices.push(idx);
      }
    });

    // If no cadences are valid, pick the one closest to MIN_PACKS
    if (validFreshIndices.length === 0) {
      let closestIdx = 0;
      let closestDiff = Infinity;
      mealRecommendationAndFrequencyData.forEach((freq, idx) => {
        const weeks = parseInt(freq.weeks);
        const naturalPacks = Math.ceil(dailyPacks * weeks * 7);
        const diff = Math.abs(naturalPacks - freshMinPacks);
        if (diff < closestDiff) {
          closestDiff = diff;
          closestIdx = idx;
        }
      });
      validFreshIndices = [closestIdx];
    }
  }

  // When a pet just switched, recalculate cadence for the new pet
  // (don't use the stale frequency dropdown value from the previous pet)
  const useDropdownValue = frequencySelector && frequencySelector.value
    && isMealRecModalOpen && !petJustSwitched;

  if (useDropdownValue) {
    // Use the frequency the user manually selected in the modal
    selectedFrequencyWeeks = parseInt(frequencySelector.value);
    const matchingIndex = mealRecommendationAndFrequencyData.findIndex(
      freq => parseInt(freq.weeks) === selectedFrequencyWeeks
    );
    if (matchingIndex !== -1) {
      // For fresh, only allow if this cadence is valid
      if (!validFreshIndices || validFreshIndices.includes(matchingIndex)) {
        selectedFrequencyIndex = matchingIndex;
      } else {
        // User's selection is no longer valid; fall through to auto-select
        selectedFrequencyWeeks = null;
      }
    }
  }

  if (!useDropdownValue || selectedFrequencyWeeks === null) {
    if (savedFrequencyWeeks) {
      // Load saved frequency for this pet
      selectedFrequencyWeeks = savedFrequencyWeeks;
      const matchingIndex = mealRecommendationAndFrequencyData.findIndex(
        freq => parseInt(freq.weeks) === savedFrequencyWeeks
      );
      if (matchingIndex !== -1) {
        if (!validFreshIndices || validFreshIndices.includes(matchingIndex)) {
          selectedFrequencyIndex = matchingIndex;
        } else {
          // Saved frequency not valid for this pet; fall through to auto-select
          selectedFrequencyWeeks = null;
        }
      }
    }

    // Auto-select best cadence for fresh if not yet determined
    if (selectedFrequencyWeeks === null && validFreshIndices && validFreshIndices.length > 0) {
      // Among valid cadences, prefer the one closest to 2 weeks
      let bestIdx = validFreshIndices[0];
      let bestDiff = Infinity;
      validFreshIndices.forEach((idx) => {
        const weeks = parseInt(mealRecommendationAndFrequencyData[idx].weeks);
        const diff = Math.abs(weeks - 2);
        if (diff < bestDiff) {
          bestDiff = diff;
          bestIdx = idx;
        }
      });
      selectedFrequencyIndex = bestIdx;
      selectedFrequencyWeeks = parseInt(mealRecommendationAndFrequencyData[selectedFrequencyIndex].weeks);
    }
  }

  // Clear the pet-switched flag now that we've used it
  petJustSwitched = false;

  const selectedFrequency = mealRecommendationAndFrequencyData[selectedFrequencyIndex];
  const mealAmountPerShippingAmount = selectedFrequency.amountInLbs;
  const mealAmountPerFirstShippingAmount = mealRecommendationAndFrequencyData[0].amountInLbs;

  const productId = form.dataset.productId;

  const shopifyVariants = getProductVariants(productId);

  const shopifyVariant = shopifyVariants.find(
    (v) => String(v.id) === variantId
  );

  if (!shopifyVariant) {
    console.warn('Shopify variant not found for id', variantId);
    return;
  }

  // Use the selected frequency amount when modal is open or frequency is selected
  const pdpAmountToUse = (isMealRecModalOpen || selectedFrequencyWeeks) ? mealAmountPerShippingAmount : mealAmountPerFirstShippingAmount;
  let currentVariant = shopifyVariant;

  if (isFreshProduct) {
    // Fresh products: select 1lb pack when dog weight >= 40 lb, else 0.5lb
    // Match by SKU since option2 titles vary (e.g. "SINGLE HALF LB", "SINGLE 1LB")
    const petWeight = recommendedPetWeight || 0;
    const prefer1lb = petWeight >= 40;

    const findFreshVariant = (sizeType) => shopifyVariants.find((v) => {
      if (v.option1 !== shopifyVariant.option1) return false;
      const sku = (v.sku || '').toLowerCase();
      if (!sku.includes('single')) return false;
      if (sizeType === 'half') return sku.includes('halflb') || sku.includes('half-lb');
      return (sku.includes('1lb') || sku.includes('1-lb')) && !sku.includes('halflb');
    });

    if (prefer1lb) {
      const oneLbVariant = findFreshVariant('1lb');
      if (oneLbVariant) {
        currentVariant = oneLbVariant;
      } else {
        const halfLbVariant = findFreshVariant('half');
        if (halfLbVariant) currentVariant = halfLbVariant;
      }
    } else {
      const halfLbVariant = findFreshVariant('half');
      if (halfLbVariant) currentVariant = halfLbVariant;
    }
  } else {
    // FDR: 32oz (Large) when >= 4 lbs recommended, else 16oz (Small)
    const preferLargeVariant = pdpAmountToUse >= 4;

    if (preferLargeVariant) {
      const largeVariant = shopifyVariants.find(
        (v) =>
          v.option1 === shopifyVariant.option1 &&
          v.option2?.includes('Large')
      );
      if (largeVariant) {
        currentVariant = largeVariant;
      } else {
        const smallVariant = shopifyVariants.find(
          (v) =>
            v.option1 === shopifyVariant.option1 &&
            v.option2?.includes('Small')
        );
        if (smallVariant) currentVariant = smallVariant;
      }
    } else {
      const smallVariant = shopifyVariants.find(
        (v) =>
          v.option1 === shopifyVariant.option1 &&
          v.option2?.includes('Small')
      );
      if (smallVariant) currentVariant = smallVariant;
    }
  }

  // Apply the recommendation to the PDP using the selected frequency amount
  selectRecommendedProduct(null, flavorHandle, currentVariant, pdpAmountToUse);

  // Determine pack size for fresh product frequency filtering
  const currentPackSize = isFreshProduct ? (amounts[variantId].fresh_pack_size_lbs || 0.5) : null;

  // Filter PDP frequency dropdown by pack size + valid cadences
  if (isFreshProduct) {
    filterPDPFrequencyOptions(currentPackSize, validFreshIndices, mealRecommendationAndFrequencyData, selectedFrequencyWeeks);
  }

  // Filter the modal frequency dropdown to only show valid cadences for fresh
  // (applied even when modal is closed so it's ready when opened)
  filterModalFrequencyOptions(validFreshIndices, mealRecommendationAndFrequencyData, selectedFrequencyWeeks, currentPackSize);

  // Store frequency data for cadence-change price updates.
  // Must be set AFTER selectRecommendedProduct / filter calls, because those
  // dispatch variant:change which could otherwise race with this assignment.
  const packSizeLbs = isFreshProduct ? (amounts[variantId].fresh_pack_size_lbs || 0.5) : null;
  lastFrequencyData = {
    data: mealRecommendationAndFrequencyData,
    isFresh: isFreshProduct,
    packSizeLbs: packSizeLbs
  };

  updatePetProfileWithMealType(flavorHandle);

  // Only update the modal UI when it is actually open
  if (isMealRecModalOpen) {

    handleModalRecommendations(
      mealAmountPerShippingAmount, // size in lbs (based on selected frequency)
      selectedFrequency, // frequency object (selected one)
      null, // dropdown item
      flavorHandle, // flavor name
      dailyServingSize, // daily serving in cups (FDR) or lbs (Fresh)
      currentVariant, // variant object
      isFreshProduct // Fresh product flag
    );

    const allowedEmails = ['walkeradkins@gmail.com', 'mikez@getjoyfood.com'];
    if (customerEmail && allowedEmails.includes(customerEmail.toLowerCase())) {
      const nutrition = amounts?.[variantId];
      if (nutrition) {
        // Delay so it doesn't block modal rendering
        setTimeout(() => appendNutritionData(nutrition), 500);
      }
    }
  }
}

function appendNutritionData(data) {
  let message;
  if (data.fresh_daily_grams) {
    // Fresh product debug view
    const cupDensity = data.fresh_cup_density || getFreshCupDensity(data.flavor_nutrition.flavor);
    const dailyCupsExact = data.fresh_daily_cups || (data.fresh_daily_grams / cupDensity.grams_per_cup);
    const dailyOzExact = data.fresh_daily_oz || (dailyCupsExact * cupDensity.oz_per_cup);
    const dailyCupsRounded = roundToFractionCups(dailyCupsExact);
    const dailyPacks = (data.fresh_daily_lbs / data.fresh_pack_size_lbs).toFixed(2);
    const packLabel = data.fresh_pack_size_lbs === 1 ? '1lb' : '0.5lb';
    message = `
    Flavor: ${data.flavor_nutrition.flavor}
    Calories per gram: ${data.flavor_nutrition.kcal_gram}
    Daily calories needed: ${(data.fresh_daily_grams * data.flavor_nutrition.kcal_gram).toFixed(0)} kcal
    Daily grams: ${data.fresh_daily_grams.toFixed(1)}g
    Daily oz: ${dailyOzExact.toFixed(2)} oz (${cupDensity.oz_per_cup} oz/cup)
    Daily cups: ~${formatCupsFraction(dailyCupsRounded)} (${cupDensity.grams_per_cup}g/cup)
    Daily packs (${packLabel}): ${dailyPacks}
    Delivery: ${data.fresh_packs_per_delivery} packs every ${data.fresh_delivery_days} days
    `;
  } else {
    // FDR product debug view
    message = `
    Flavor: ${data.flavor_nutrition.flavor}
    Density: ${data.flavor_nutrition.density} g/cup
    Calories per gram: ${data.flavor_nutrition.kcal_gram}
    Calories per cup: ${data.flavor_nutrition.per_cup.toFixed(1)}
    Meal size: ${data.meal_cups_rounded} cups (${data.meal_cups_html.replace(/<[^>]+>/g, '')})
    `;
  }

  alert(message.trim());
}

// Per-protein density: grams per cup and oz per cup
// These vary by recipe and must match the client's spreadsheet exactly.
const FRESH_CUP_DENSITY = {
  beef:    { grams_per_cup: 254.6, oz_per_cup: 8.98 },
  chicken: { grams_per_cup: 258.2, oz_per_cup: 9.11 },
  turkey:  { grams_per_cup: 246.6, oz_per_cup: 8.70 },
  lamb:    { grams_per_cup: 236.2, oz_per_cup: 8.33 }
};

function getFreshCupDensity(flavor) {
  const key = (flavor || '').toLowerCase().replace(/[^a-z]/g, '');
  return FRESH_CUP_DENSITY[key] || FRESH_CUP_DENSITY.beef; // fallback to beef
}

function handleFreshAmounts(energy) {
  if (!energy) return;

  const GRAMS_PER_LB = 453.592;
  const MIN_PACKS = 14;
  const MAX_PACKS_HALF_LB = 42;
  const MAX_PACKS_ONE_LB = 34;

  // Get fresh flavor nutrition data from the hidden textarea
  const freshDataEl = document.querySelector(
    'textarea[data-content="fresh-flavor-nutrition"]'
  );
  if (!freshDataEl) return;

  let freshVariants;
  try {
    freshVariants = JSON.parse(freshDataEl.value.trim());
    // Filter out trailing null/empty entries from Liquid comma handling
    freshVariants = freshVariants.filter((v) => v && v.variant_id);
  } catch (e) {
    console.warn('Failed to parse fresh flavor nutrition data', e);
    return;
  }

  // Group by flavor and calculate daily grams needed
  const flavorMap = {};
  freshVariants.forEach((v) => {
    if (!flavorMap[v.variant_flavor]) {
      flavorMap[v.variant_flavor] = {
        kcal_gram: v.kcal_gram,
        variants: []
      };
    }
    flavorMap[v.variant_flavor].variants.push(v);
  });

  // Determine pack size based on dog weight: >= 40 lb → 1 lb packs, else 0.5 lb
  const petWeight = recommendedPetWeight || 0;
  const packSizeLbs = petWeight >= 40 ? 1 : 0.5;
  const maxPacks = packSizeLbs === 1 ? MAX_PACKS_ONE_LB : MAX_PACKS_HALF_LB;
  console.log('[Fresh] petWeight:', petWeight, '→ packSize:', packSizeLbs, 'lb');

  // Build amounts keyed by variant ID
  // Fresh meals use full daily calories (100% fresh diet, matching spreadsheet feeding guide)
  const amountsById = {};
  Object.entries(flavorMap).forEach(([flavor, data]) => {
    if (!data.kcal_gram || data.kcal_gram === 0) return;

    const dailyGrams = energy / data.kcal_gram;
    const dailyLbs = dailyGrams / GRAMS_PER_LB;
    const dailyPacks = dailyLbs / packSizeLbs;
    const cupDensity = getFreshCupDensity(flavor);
    const dailyCupsExact = dailyGrams / cupDensity.grams_per_cup;
    const dailyOzExact = dailyCupsExact * cupDensity.oz_per_cup;

    // Calculate optimal delivery interval (in whole weeks) to keep packs within [MIN_PACKS, maxPacks]
    let deliveryDays = 14; // Start with 2 weeks
    let packs = Math.ceil(dailyPacks * deliveryDays);

    if (packs < MIN_PACKS) {
      // Increase cadence to meet minimum
      deliveryDays = Math.ceil(MIN_PACKS / dailyPacks);
      // Round up to whole weeks
      deliveryDays = Math.ceil(deliveryDays / 7) * 7;
    } else if (packs > maxPacks) {
      // Decrease cadence to stay within maximum
      deliveryDays = Math.floor(maxPacks / dailyPacks);
      // Round down to whole weeks (min 1 week)
      deliveryDays = Math.max(7, Math.floor(deliveryDays / 7) * 7);
    }

    packs = Math.ceil(dailyPacks * deliveryDays);
    // Final clamp to ensure bounds
    packs = Math.max(MIN_PACKS, Math.min(maxPacks, packs));

    const deliveryLbs = packs * packSizeLbs;

    data.variants.forEach((v) => {
      amountsById[v.variant_id] = {
        flavor_nutrition: {
          id: v.variant_id,
          flavor: v.variant_flavor,
          kcal_gram: v.kcal_gram,
          per_cup: 0, // Not applicable for fresh
          density: 0
        },
        meal_cups_value: 0,
        meal_cups_rounded: dailyLbs, // Store daily lbs for recommendation calc
        meal_cups_html: `${dailyGrams.toFixed(0)}g`,
        // Fresh-specific data
        fresh_daily_grams: dailyGrams,
        fresh_daily_lbs: dailyLbs,
        fresh_daily_cups: dailyCupsExact,
        fresh_daily_oz: dailyOzExact,
        fresh_cup_density: cupDensity,
        fresh_delivery_lbs: deliveryLbs,
        fresh_delivery_days: deliveryDays,
        fresh_pack_size_lbs: packSizeLbs,
        fresh_packs_per_delivery: packs
      };
    });
  });

  handleProductRecommendation(amountsById, true);
}

function handleDriedAmounts(energy) {
  if (energy) {
    let flavorNutrition = [];
    variantNutrition.forEach((variant) => {
      if (!variant.kcal_gram || !variant.density) return;
      let flavor = {
        id: variant.id,
        flavor: variant.flavor,
        density: variant.density,
        kcal_gram: variant.kcal_gram,
        per_cup: variant.density * variant.kcal_gram
      };
      flavorNutrition.push(flavor);
    });

    let servingAmounts = parseServingAmount(energy, flavorNutrition);
    const amountsById = servingAmounts.reduce((acc, item) => {
      acc[item.flavor_nutrition.id] = item;
      return acc;
    }, {});

    handleProductRecommendation(amountsById, true);

    // bulkUnhide(
    //   document.querySelectorAll(`[data-content="ffd-pet-conditional"]`)
    // );
  }
}

function parseAvailableSizes(flavor) {
  let sizeOptions = variantNutrition.filter(
    (object) => object.flavor === flavor
  );
  if (sizeOptions[0].size) {
    // Accounts for option title discrepancies between ffd / fresh
    return sizeOptions.map((option) => parseGramSizeInt(option.size));
  } else {
    return sizeOptions.map((option) => parseOzSizeInt(option.bag_size));
  }
}

function parsePresetMealSize(grams, sizes) {
  let mealSize = sizes[0];
  let smallestDifference = Math.abs(grams - mealSize);
  for (let i = 1; i < sizes.length; i++) {
    let size = sizes[i];
    let currentDifference = Math.abs(grams - size);
    if (currentDifference < smallestDifference) {
      smallestDifference = currentDifference;
      mealSize = size;
    }
  }
  return mealSize;
}

// Turns decimals into fractions (supports 1/8ths and 1/3rds)
function parseFractionCups(decimal) {
  if (decimal === '0.125' || decimal === '125') {
    return '1/8';
  } else if (decimal === '0.25' || decimal === '25') {
    return '1/4';
  } else if (decimal === '0.333' || decimal === '333') {
    return '1/3';
  } else if (decimal === '0.375' || decimal === '375') {
    return '3/8';
  } else if (decimal === '0.5' || decimal === '5') {
    return '1/2';
  } else if (decimal === '0.625' || decimal === '625') {
    return '5/8';
  } else if (decimal === '0.667' || decimal === '667') {
    return '2/3';
  } else if (decimal === '0.75' || decimal === '75') {
    return '3/4';
  } else if (decimal === '0.875' || decimal === '875') {
    return '7/8';
  } else {
    return '';
  }
}

// Round cups to nearest common fraction (1/4, 1/3, 1/2, 2/3, 3/4, etc.)
// Uses 1/12ths internally so both 1/4 and 1/3 increments are covered.
function roundToFractionCups(cups) {
  const twelfths = Math.round(cups * 12) / 12;
  return Math.round(twelfths * 1000) / 1000; // clean float noise
}

// Format a cups value (already rounded) to a readable string like "1 1/3 cups"
function formatCupsFraction(cups) {
  const whole = Math.floor(cups);
  const frac = Math.round((cups - whole) * 1000) / 1000;

  // Map common twelfths fractions
  let fracStr = '';
  if (Math.abs(frac - 0.083) < 0.01) fracStr = '1/12';
  else if (Math.abs(frac - 0.125) < 0.01) fracStr = '1/8';
  else if (Math.abs(frac - 0.167) < 0.01) fracStr = '1/6';
  else if (Math.abs(frac - 0.25) < 0.01) fracStr = '1/4';
  else if (Math.abs(frac - 0.333) < 0.01) fracStr = '1/3';
  else if (Math.abs(frac - 0.375) < 0.01) fracStr = '3/8';
  else if (Math.abs(frac - 0.417) < 0.01) fracStr = '5/12';
  else if (Math.abs(frac - 0.5) < 0.01) fracStr = '1/2';
  else if (Math.abs(frac - 0.583) < 0.01) fracStr = '7/12';
  else if (Math.abs(frac - 0.625) < 0.01) fracStr = '5/8';
  else if (Math.abs(frac - 0.667) < 0.01) fracStr = '2/3';
  else if (Math.abs(frac - 0.75) < 0.01) fracStr = '3/4';
  else if (Math.abs(frac - 0.833) < 0.01) fracStr = '5/6';
  else if (Math.abs(frac - 0.875) < 0.01) fracStr = '7/8';
  else if (Math.abs(frac - 0.917) < 0.01) fracStr = '11/12';
  else if (frac > 0.01) fracStr = frac.toFixed(2);

  let display = '';
  if (whole > 0 && fracStr) display = `${whole} ${fracStr}`;
  else if (whole > 0) display = `${whole}`;
  else if (fracStr) display = fracStr;
  else display = '0';

  const unit = cups === 1 ? 'cup' : 'cups';
  return `${display} ${unit}`;
}

function parseServingAmount(calories, flavors) {
  const mealMer = calories / 2;

  return flavors.map((flavor) => {
    let mealCups = mealMer / flavor.per_cup;
    let roundedCups = Math.round(mealCups * 8) / 8;
    let [wholeNumber, fractional] = String(roundedCups).split('.');

    let displayAmount = wholeNumber !== '0' ? wholeNumber : '';
    if (fractional) {
      let [numerator, denominator] = parseFractionCups(fractional).split('/');
      displayAmount += ` <sup>${numerator}</sup>/<sub>${denominator}</sub>`;
    }

    let displayUnit = roundedCups === 1 ? 'cup' : 'cups';
    let fullDisplay = `${displayAmount} ${displayUnit}`;

    return {
      flavor_nutrition: flavor,
      meal_cups_value: mealCups,
      meal_cups_rounded: roundedCups,
      meal_cups_html: fullDisplay
    };
  });
}

function setFreshSizeValue(formId, size, type) {
  let form = document.querySelector(
    `[data-content="product-form"][data-form-product="${formId}"]`
  );
  let sizeInput = form.querySelector('[data-content="variant-size"]');
  if (sizeInput.type === 'select-one') {
    sizeInput.value = size;
  } else {
    sizeInput = form.querySelector(
      `[data-content="variant-size"][value="${size}"]`
    );
    sizeInput.checked = true;
  }
  handleVariantChange();
}

function parseAgeMonths(age) {
  return Number(age) * 12;
}

function parseRer(weight) {
  let kgWeight = parseInt(weight) / 2.2;
  let metabolicWeight = kgWeight ** 0.75;
  return metabolicWeight * 70;
}

function parseSizeGroup(petData) {
  if (
    petData.breed === 'Mixed / Other...' ||
    !petData.breed ||
    petData.breed === ''
  ) {
    return parseMixedSize(parseAgeMonths(petData.age), petData.weight);
  }
  return petData.other_size &&
    petData.breed === 'Mixed / Other...' &&
    petData.other_size !== ''
    ? petData.other_size
    : parseBreedSize(petData.breed);
}

function parseBreedSize(breed) {
  const lowerBreed = breed.toLowerCase();
  if (
    giantBreeds.some((giantBreed) => giantBreed.toLowerCase() === lowerBreed)
  ) {
    return 'giant';
  }
  if (
    largeBreeds.some((largeBreed) => largeBreed.toLowerCase() === lowerBreed)
  ) {
    return 'large';
  }
  if (
    mediumBreeds.some((mediumBreed) => mediumBreed.toLowerCase() === lowerBreed)
  ) {
    return 'medium';
  }
  return 'small';
}

function parseLifestage(age) {
  if (age < 12) return 'puppy';
  if (age < 84) return 'adult';
  return 'senior';
}

function parseMer(petData, stage, rer) {
  const lifestageMultiplier = rerMultipliers[stage];

  // All dogs default to neutered (0.85)
  const neuterMultiplier = 0.85;

  // Activity: 'laid-back' / 'laid_back' → lazy key (0.80), 'active' → active key (1.0)
  const activityNormalize = { 'laid-back': 'lazy', 'laid_back': 'lazy' };
  const activityRaw = (petData.activity && petData.activity.toLowerCase()) || 'lazy';
  const activityKey = activityNormalize[activityRaw] || activityRaw;
  const activityMultiplier =
    (conditionalMultipliers.activity && conditionalMultipliers.activity[activityKey]) || 1;

  // Weight goal derived from body type
  const bodyTypeGoalMap = {
    'a-bit-skinny': 'gain',
    'a_bit_skinny': 'gain',
    'ideal': 'maintain',
    'more-to-love': 'loss',
    'more_to_love': 'loss'
  };
  const weightGoalValue =
    (petData.weight_goal && petData.weight_goal.toLowerCase()) ||
    (petData.bodyType && bodyTypeGoalMap[petData.bodyType.toLowerCase()]) ||
    'maintain';
  const weightGoalMultiplier =
    (conditionalMultipliers.goal && conditionalMultipliers.goal[weightGoalValue]) || 1;

  // merTransform = 0.84 digestibility factor (from Shopify mer_modifier setting)
  return rer * lifestageMultiplier * neuterMultiplier * activityMultiplier * weightGoalMultiplier * merTransform;
}

function parseConditionalEnergy(type, value, base) {
  const activityNormalize = {
    'laid_back': 'lazy',
    'laid-back': 'lazy',
    'x-active': 'x_active'
  };
  let keyType = type.replace('-', '_');
  let keyValue = value.replace('-', '_');
  if (keyType === 'activity' && activityNormalize[keyValue]) {
    keyValue = activityNormalize[keyValue];
  }
  let multiplier = (conditionalMultipliers[keyType] && conditionalMultipliers[keyType][keyValue]) || 1;
  return base * multiplier - base;
}

function parseMixedSize(age, weight) {
  let calcWeight;
  if (age < 3) {
    calcWeight = weight * 2.5;
  } else if (age < 5) {
    calcWeight = weight * 1.75;
  } else if (age < 8) {
    calcWeight = weight * 1.5;
  } else if (age < 12) {
    calcWeight = weight * 1.2;
  } else {
    calcWeight = weight;
  }
  return calcWeight <= 25
    ? 'small'
    : calcWeight <= 50
      ? 'medium'
      : calcWeight <= 90
        ? 'large'
        : 'giant';
}

function initQuantityPresetButtons() {
  const presetButtons = document.querySelectorAll('[data-quantity-preset]');
  const presetLabels = document.querySelectorAll('[data-quantity-label]');

  if (presetButtons.length === 0) return;

  const unitPrices = storeInitialUnitPrices();

  presetButtons.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        const quantity = parseInt(radio.dataset.quantityValue, 10);
        handleQuantityPresetChange(quantity, unitPrices, presetLabels);
      }
    });
  });

  const checkedButton = document.querySelector(
    '[data-quantity-preset]:checked'
  );
  if (checkedButton) {
    const initialQuantity = parseInt(checkedButton.dataset.quantityValue, 10);
    handleQuantityPresetChange(initialQuantity, unitPrices, presetLabels);
  }
}

// Handle variant-input buttons (for size/bag options using quantity-selector-buttons style)
function initVariantInputButtonStyles() {
  const variantButtons = document.querySelectorAll('.quantity-selector-buttons [data-variant-input]');

  if (variantButtons.length === 0) return;

  variantButtons.forEach((radio) => {
    radio.addEventListener('change', () => {
      updateVariantButtonStyles(radio);
    });
  });

  // Initialize on page load
  const checkedButton = document.querySelector('.quantity-selector-buttons [data-variant-input]:checked');
  if (checkedButton) {
    updateVariantButtonStyles(checkedButton);
  }
}

function updateVariantButtonStyles(checkedInput) {
  const container = checkedInput.closest('.quantity-selector-buttons');
  if (!container) return;

  // Get the name attribute to only update buttons in the same radio group
  const inputName = checkedInput.getAttribute('name');
  if (!inputName) return;

  // Only update buttons with the same name (same radio group)
  const allInputs = container.querySelectorAll(`[data-variant-input][name="${inputName}"]`);

  allInputs.forEach((input) => {
    const label = input.labels?.[0];
    if (!label) return;

    if (input.checked) {
      // Selected state
      label.classList.remove('bg-[#002B5473]', 'opacity-60');
      label.classList.add('bg-[#002B54]');
    } else {
      // Unselected state
      label.classList.remove('bg-[#002B54]');
      label.classList.add('bg-[#002B5473]', 'opacity-60');
    }
  });
}

function storeInitialUnitPrices() {
  const prices = { autoship: null, compare: null };

  const autoshipPriceEl = document.querySelector(
    '[data-content="current-autoship-price"]'
  );
  const comparePriceEl = document.querySelector(
    '[data-content="compare-price"]'
  );

  if (autoshipPriceEl) {
    prices.autoship = parsePriceFromText(autoshipPriceEl.textContent);
  }

  if (comparePriceEl) {
    prices.compare = parsePriceFromText(comparePriceEl.textContent);
  }

  return prices;
}

function parsePriceFromText(priceText) {
  if (!priceText || priceText.trim() === '') return null;
  const cleanPrice = priceText.replace(/[$,\s]/g, '');
  const price = parseFloat(cleanPrice);
  return isNaN(price) ? null : price;
}

function formatPriceForDisplay(price) {
  return (
    '$' +
    price.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
}

function handleQuantityPresetChange(quantity, unitPrices, labels) {
  updateQuantityInput(quantity);
  updatePriceDisplays(quantity, unitPrices);
  updatePresetButtonStyles(quantity, labels);
  triggerPriceRecalculation(quantity);
}

function getQuantityInput() {
  return (
    document.querySelector('[data-content="variant-quantity"]') ||
    document.querySelector('.js-qty__num') ||
    document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
  );
}

function updateQuantityInput(quantity) {
  const quantityInput = getQuantityInput();
  if (quantityInput) {
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

function updatePriceElement(selector, unitPrice, quantity) {
  const element = document.querySelector(selector);
  if (element && unitPrice !== null) {
    element.textContent = formatPriceForDisplay(unitPrice * quantity);
  }
}

function updatePriceDisplays(quantity, unitPrices) {
  updatePriceElement(
    '[data-content="current-autoship-price"]',
    unitPrices.autoship,
    quantity
  );
  updatePriceElement(
    '[data-content="compare-price"]',
    unitPrices.compare,
    quantity
  );
}

function updatePresetButtonStyles(selectedValue, _labels) {
  const selectedStr = String(selectedValue);

  // Always re-query live so dynamically injected buttons (e.g. "FOR PET") are included
  const allLabels = document.querySelectorAll('[data-quantity-label]');

  allLabels.forEach((label) => {
    // Skip labels that belong to variant-input buttons (bag size, etc)
    const inputId = label.getAttribute('for');
    const input = document.getElementById(inputId);
    if (input && input.hasAttribute('data-variant-input')) {
      return; // Skip variant-input labels
    }

    const isActive = label.dataset.quantityValue === selectedStr;

    // Update CSS classes for active/inactive states
    if (isActive) {
      label.classList.remove('bg-[#002B5473]', 'opacity-60');
      label.classList.add('bg-[#002B54]');
    } else {
      label.classList.remove('bg-[#002B54]');
      label.classList.add('bg-[#002B5473]', 'opacity-60');
    }
  });
}

function triggerPriceRecalculation(quantity) {
  const productSection = document.querySelector(
    '[data-section-type="product"]'
  );
  if (!productSection) return;

  const productId = productSection.dataset.productId;
  if (!productId) return;

  const variant = parseCurrentSelection(productId);
  if (!variant) return;

  handlePriceUpdatesWithQuantityInput(variant, productId, quantity);
}

/**
 * Called when the user manually changes the PDP frequency dropdown.
 * Looks up the quantity for the new cadence from the stored recommendation
 * data and updates quantity + price to match.
 */
function handleCadenceChange(selectedWeeks) {
  if (!lastFrequencyData || !lastFrequencyData.data) return false;

  const freqData = lastFrequencyData.data;
  const match = freqData.find(f => Number(f.weeks) === selectedWeeks);
  if (!match) return false;

  const packSize = lastFrequencyData.packSizeLbs || 1;
  const newQty = lastFrequencyData.isFresh
    ? Math.ceil(match.amountInLbs / packSize)
    : Math.ceil(match.amountInLbs);

  // Update quantity input and preset button styles
  updateQuantityInput(newQty);

  const allQtyContainers = document.querySelectorAll(
    '.quantity-selector-buttons:not([data-quantity-mode])'
  );
  const presetContainer = Array.from(allQtyContainers).find(
    el => el.querySelector('[data-quantity-preset]')
  );
  if (presetContainer) {
    const allPresetLabels = presetContainer.querySelectorAll('[data-quantity-label]');
    updatePresetButtonStyles(newQty, allPresetLabels);
  }

  // Recalculate price using the selling plan allocation's per-unit price × new qty
  triggerPriceRecalculation(newQty);
  return true;
}

// FIX: Ensure selling_plan selects have values before form submission
// This prevents subscriptions from being added as one-time purchases when
// the select's selectedIndex becomes -1 (no selection)
document.addEventListener('DOMContentLoaded', function() {
  const productForms = document.querySelectorAll('form[action="/cart/add"]');

  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const allSelects = form.querySelectorAll('select[name="selling_plan"]');

      allSelects.forEach(function(select) {
        // If select is enabled but has no value, set it to first option
        if (!select.disabled && (!select.value || select.value === '' || select.selectedIndex === -1)) {
          if (select.options.length > 0) {
            select.selectedIndex = 0;
          }
        }
      });
    }, true); // Use capture phase to ensure this runs first
  });
});
